<template>
  <div class="cruiseDetail-content">
    <div
      class="packageDetail"
      v-if="cruiseDetail && cruiseDetail.cruiseId > 0"
      ref="cruiseDetail"
    >
      <div
        class="packageDetail-tip"
        v-if="
          cruiseDetail.price &&
          cruiseDetail.price.nrpAmout > 0 &&
          cruiseDetail.price.netAmout > 0
        "
      >
        <img src="https://resource.rcclchina.com.cn/tui2/icon01.png" />
        <div class="packageDetail-tip-txt">
          您可选2套价格方案：推荐早订特惠(收费退订)
        </div>
      </div>
      <div class="packageDetail-banner">
        <div
          class="swiper-container bannerSwiper"
          v-if="cruiseDetail && cruiseDetail.banners"
          v-swiper:bannerSwiper="swiperOption"
        >
          <div v-if="cruiseDetail.isShowDeadlineSaleCountdown" class='salesCountdownBox'>
            <div class="barDesc">距关闭仅剩</div>
            <uCountDown  :timestamp="cruiseDetail.deadlineSaleCountdownTotalSeconds"/>
          </div>
          <div class="swiper-wrapper" style="height: auto">
            <div
              v-for="(item, i) in cruiseDetail.banners"
              :key="i"
              class="swiper-slide"
              data-swiper-autoplay="5000"
            >
              <img :src="item" />
            </div>
          </div>
          <div class="swiperOrder">
            <span id="cruiseDetailBannerIndex">{{ bannerIndex }}</span
            >/{{ cruiseDetail.banners.length }}
          </div>
        </div>
        <div class="packageDetail-like js-likeBtn" @click="onWishListClick()">
          <div>
            <img
              src="https://resource.rcclchina.com.cn/mobileSearchPackage/likeIcon.png"
              v-if="!isInWishList"
            />
            <img
              src="https://resource.rcclchina.com.cn/mobileSearchPackage/likeActiveIcon.png"
              v-if="isInWishList"
            />
          </div>
          <p class="cruiseWish">{{ collections }}</p>
        </div>
      </div>

      <div class="packageDetail-cruiseInfo">
        <div class="packageDetail-cruiseInfo-title">
          {{ cruiseDetail.routeName }}
        </div>
        <div class="packageDetail-cruiseInfo-sailDays" style="display: flex;gap: 8px">
          {{
            cruiseDetail.sailDays + "天" + (cruiseDetail.sailDays - 1) + "晚"
          }}&nbsp;&nbsp;&nbsp;&nbsp;{{ cruiseDetail.shipName }}
        </div>
        <div class="item-refund" v-if="cruiseDetail.isSevenDayNrpCruise">
          <img
            src="https://resource.rcclchina.com.cn/cruiseSearch/ease_refund_7_day.png"
          />
        </div>
        <div class="item-refund" v-if="cruiseDetail.isShowRefund">
          <img
            src="https://resource.rcclchina.com.cn/cruiseSearch/ease_refund_update.png"
          />
        </div>

        <div class="packageDetail-cruiseInfo-sailDate">
          <span
            >{{ cruiseDetail.sailDateBegin }}
            <i
              style="
                display: inline-block;
                width: 8px;
                height: 1px;
                background-color: #666;
                vertical-align: middle;
                margin: 0 4px;
              "
            ></i>
            {{ cruiseDetail.sailDateEnd }}
          </span>
          <span
            class="packageDetail-cruiseInfo-otherDate js-moreSailDateBtn"
            @click="onCruiseCalendarClick"
          >
            <img
              src="https://resource.rcclchina.com.cn/mobileSearchPackage/calendarIcon.png"
            />
            <span>更多日期</span>
          </span>
        </div>
        <div
          class="packageDetail-cruiseInfo-price"
          v-if="
            cruiseDetail.price && cruiseDetail.price.nrpAmout > 0 && isShowNrp
          "
        >
          早订特惠价(含税）
          <div class="packageDetail-cruiseInfo-price-txt">
            <span>¥</span>{{ cruiseDetail.price.nrpAmout }}
          </div>
          /人起
        </div>
        <div
          class="packageDetail-cruiseInfo-price"
          v-if="
            cruiseDetail.price && cruiseDetail.price.netAmout > 0 && !isShowNrp
          "
        >
          优惠价(含税）
          <div class="packageDetail-cruiseInfo-price-txt">
            <span>¥</span>{{ cruiseDetail.price.netAmout }}
          </div>
          /人起
        </div>
        <div
          v-if="cruiseDetail.tags && cruiseDetail.tags.length > 0"
          class="packageDetail-cruiseInfo-tags"
        >
          <div class="promptHot" v-if="cruiseDetail.choosenSupport">
            <img
              src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-hot.jpg"
            />
            <span>爆款</span>
          </div>
          <span
            v-for="(tag, i) in cruiseDetail.tags"
            :key="i"
            :class="{
              highShow: tag.isHightShow,
              tagLink: tag.link && tag.link.length > 0,
            }"
            class="tagDetail"
          >
            <a
              target="_blank"
              :href="tag.link"
              v-if="tag.link && tag.link.length > 0"
              >{{ tag.name }}</a
            >
            <span v-else @click="showCruiseTagPopup">{{ tag.name }}</span>
          </span>

          <div class="tags-rule js-tagDetailBtn">
            <a @click.prevent="showCruiseTagPopup">优惠说明</a>
            <img src="https://resource.rcclchina.com.cn/RcclHP/icon08.png" />
          </div>
        </div>
        <div class="receive-coupon"
             v-if="coupons&&coupons.length>0">
          <div class="coupon-item" :class="i.couponState===2 ? 'coupon-claimed':''"
               v-for="(i,idx) in coupons" :key="idx"
               @click="onGetCouponClick(i)">
            <div class="item-left">
              {{i.promotion}}
            </div>
            <div class="item-right">
              <span v-if="i.couponState===1">领</span>
              <span v-else>已领</span>
            </div>
          </div>
        </div>
        <div v-if="vrUrl && vrUrl.length>0" class="viewVrMiniSite">
          <a :href="vrUrl" target="_blank">
            <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/vrImg/vrIcon.png" alt="">
            进入VR
          </a>
        </div>
      </div>
      <div class="countdown-main" v-if="cruiseCampaign && cruiseCampaign.type===1 && cruiseCampaign.isShowCruiseCampaign">
        <div class="countdown-title">
          <div class="title-con">
            <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/routesDetail/2023/countDown-icon.png" alt=""/>
            <div>{{cruiseCampaign.title}}</div>
          </div>
          <div class="title-time" v-if="cruiseCampaign.time">
            距结束
            <div class="title-time-con">
              <template v-if="cruiseCampaign.time.d!='00'">
                <span>{{cruiseCampaign.time.d}}</span>天
              </template>
              <template v-if="cruiseCampaign.time.h!='00'">
                <span>{{cruiseCampaign.time.h}}</span>:
              </template>
              <span>{{cruiseCampaign.time.m}}</span>:<span>{{cruiseCampaign.time.s}}</span>
            </div>
          </div>
        </div>
        <div class="countdown-con">
          {{cruiseCampaign.content}}
        </div>
      </div>
      <div class="packageDetail-container">
        <div
          class="packageDetail-nav js-navChangeBtn"
          ref="detailNav"
          :class="{ outDetailNav: isNavFixed }"
        >
          <div :class="{ active: navIndex == 0 }" @click="onNavChange(0)">
            <span>添加舱房</span>
          </div>
          <div :class="{ active: navIndex == 1 }" @click="onNavChange(1)">
            <span>行程</span>
          </div>
          <div :class="{ active: navIndex == 2 }" @click="onNavChange(2)">
            <span>预订政策</span>
          </div>
          <div
            :class="{ active: navIndex == 3 }"
            @click="onNavChange(3)"
            class="review-tab"
            v-if="reviews && reviews.length > 0"
          >
            <span>游记</span>
          </div>
        </div>
        <!-- 特别礼遇 -->
        <div
          class="specialBookingText"
          v-if="
            specialBooking &&
            specialBookingName &&
            specialBookingName.length > 0
          "
          @click="showSpecialBookingPopup()"
        >
          <span>所有房型支持收费附加服务：</span>
          <span
            ><img src="https://resource.rcclchina.com.cn/wechatMiniProgram/WechatMiniProgramImage/birthdayRoom/birthday_icon.png"
          /></span>
          <span class="specialBookingName">{{ specialBookingName }} </span>
          <span class="rightArrows"><img src="https://resource.rcclchina.com.cn/wechatMiniProgram/WechatMiniProgramImage/birthdayRoom/icon-arrow-right-gold.png" alt=""></span>
        </div>
        <div class="trafficContainer" style="display: block">
          <div class="packageDetail-traffic" style="display: block">
            <div class="packageDetail-room" ref="detailRoom">
              <div class="packageDetail-roomTitle">
                <div class="packageDetail-roomTitle-l">
                  <div class="packageDetail-roomTitle-l-txt1">
                    <img
                      src="https://resource.rcclchina.com.cn/mobile2/cruiseDetail/connect/mb_cruise.png"
                    />
                    <span style="color: #4a90e2">选择游轮舱房</span>
                  </div>
                  <div
                    class="packageDetail-roomTitle-l-txt2 js-cancelRule"
                    @click="showCancelPolicyPopup()"
                  >
                    <a>取消政策</a>
                    <img
                      src="https://resource.rcclchina.com.cn/RcclHP/icon08.png"
                    />
                  </div>
                </div>
                
                <!-- 选房助手 start -->
                <div class="helper" @click="isHelperRomePopoverShowDetail = !isHelperRomePopoverShowDetail">
                    <div class="inner">
                      <img class="helper-icon" :src="currImgUrl+'searchHome.png'" mode=""/>
                    <div>选房助手</div>
                  </div>
                </div>
                <!-- 选房助手 end -->


              </div>

              <div
                ref="roomNav"
                class="packageDetail-roomNav js-roomNavBtn css-has-connect-room"
              >
                <div
                  ref="roomNavWrapper"
                  class="packageDetail-roomNav-wrapper"
                  :class="{
                    'packageDetail-roomNav-no-connectRoom': !needShowConnectRoom,
                  }"
                >
                  <div
                    class="c_room"
                    :class="{ active: this.currentGuestNumber == 1}"
                    @click="onGuestNumberChange(1)"
                  >
                    <div :class="{c_room_outOfStock:getCruiseOutOfStock()}">
                      <p>单人房</p>
                      <p v-if="cruiseDetail.outOfStockEnable">(缺货登记)</p>
                      <p v-else>(售罄)</p>
                    </div>
                  </div>
                  <div
                    class="c_room"
                    :class="{ active: this.currentGuestNumber == 2}"
                    @click="onGuestNumberChange(2)"
                  >
                    <div :class="{c_room_outOfStock:getCruiseOutOfStock()}">
                      <p>双人房</p>
                      <p v-if="cruiseDetail.outOfStockEnable">(缺货登记)</p>
                      <p v-else>(售罄)</p>
                    </div>
                  </div>
                  <div
                    class="c_room"
                    :class="{ active: this.currentGuestNumber == 3}"
                    @click="onGuestNumberChange(3)"
                  >
                    <div :class="{c_room_outOfStock:getCruiseOutOfStock()}">
                      <p
                        :class="{
                          QIAOHU_Stateroom_Number_CSS: checkHasQHRoom(3),
                        }"
                      >
                        三人房
                      </p>
                      <p
                        v-if="checkHasQHRoom(3)"
                        class="QIAOHU_Stateroom_Title_CSS"
                      >
                        限量巧虎房
                      </p>
                      <p v-if="cruiseDetail.outOfStockEnable">(缺货登记)</p>
                      <p v-else>(售罄)</p>
                    </div>
                  </div>
                  <div
                    class="c_room"
                    :class="{ active: this.currentGuestNumber == 4}"
                    @click="onGuestNumberChange(4)"
                  >
                    <div :class="{c_room_outOfStock:getCruiseOutOfStock()}">
                      <p
                        :class="{
                          QIAOHU_Stateroom_Number_CSS: checkHasQHRoom(4),
                        }"
                      >
                        四人房
                      </p>
                      <p
                        v-if="checkHasQHRoom(3)"
                        class="QIAOHU_Stateroom_Title_CSS"
                      >
                        限量巧虎房
                      </p>
                      <p v-if="cruiseDetail.outOfStockEnable">(缺货登记)</p>
                      <p v-else>(售罄)</p>
                    </div>
                  </div>
                  <div
                    v-if="needShowConnectRoom"
                    class="c_room c_last_div c_connect_room_tab"
                    :class="{ active: isConnectRoomMode}"
                    @click="isShowConnect = true"
                  >
                    <div
                      class="c_line"
                      :class="{ hasSelected: isConnectRoomMode,c_room_outOfStock:getCruiseOutOfStock()}"
                    >
                      <img
                        src="https://resource.rcclchina.com.cn/mobile2/cruiseDetail/connect/mb_con_new.png"
                        alt=""
                      />
                      <div class="c_wrap">
                        <span></span>
                      </div>
                      <div class="c_doubleroom">
                        <span class="c_room_title">多人连通房</span>
<!--                        <span class="optOfSellOut" v-if="cruiseDetail.outOfStockEnable">(缺货登记)</span>-->
                        <span class="optOfSellOut">(售罄)</span>
                        <br />
                        <span
                          class="c_room_subtitle"
                          v-if="currentConnectGuestCount == '2,2'"
                          >双人房+双人房</span
                        >
                        <span
                          class="c_room_subtitle"
                          v-else-if="currentConnectGuestCount == '2,3'"
                          >双人房+三人房</span
                        >
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              <div class="packageDetail-roomCat">
                <div class="packageDetail-roomCatCon js-roomCatBtn">
                  <div
                    class="roomCat-item"
                    :class="{
                      active: currentStateroomType == 'INTERIOR',
                      noactive: isStateroomSoldout('INTERIOR'),
                    }"
                    @click="onStateroomTypeChanged('INTERIOR')"
                  >
                    <div>内舱房</div>
                    <div
                      class="js_sailOut"
                      v-if="isStateroomSoldout('INTERIOR')"
                    >
                      <i v-if="isConnectRoomMode">
                        <span>(售罄)</span>
                      </i>
                      <i v-else>
                        <span v-if="cruiseDetail.outOfStockEnable">(缺货登记)</span>
                        <span v-else>(售罄)</span>
                      </i>
                    </div>
                  </div>
                  <div
                    class="roomCat-item"
                    :class="{
                      active: currentStateroomType == 'OUTSIDE',
                      noactive: isStateroomSoldout('OUTSIDE'),
                    }"
                    @click="onStateroomTypeChanged('OUTSIDE')"
                  >
                    <div>海景房</div>
                    <div
                      class="js_sailOut"
                      v-if="isStateroomSoldout('OUTSIDE')"
                    >
                      <i v-if="isConnectRoomMode">
                        <span>(售罄)</span>
                      </i>
                      <i v-else>
                        <span v-if="cruiseDetail.outOfStockEnable">(缺货登记)</span>
                        <span v-else>(售罄)</span>
                      </i>
                    </div>
                  </div>
                  <div
                    class="roomCat-item roomCat-item-type3"
                    :class="{
                      active: currentStateroomType == 'BALCONY',
                      noactive: isStateroomSoldout('BALCONY'),
                    }"
                    @click="onStateroomTypeChanged('BALCONY')"
                  >
                    <div>
                      <img
                        v-if="checkHasQHRoom(currentGuestNumber)"
                        src="https://resource.rcclchina.com.cn/QIAOHU/PC/MobileQIAOHU.png"
                        style="max-width: 14px; position: relative; top: 2px"
                        class="QIAOHU_CASS_ROOM_CSS"
                      />
                      阳台房
                    </div>
                    <div class="room-tags" v-if="!isStateroomSoldout('BALCONY')">
                      <img :src="`${imgUrl}/mobile/details/room_tags_hot.png`"/>
                    </div>
<!--                    <div-->
<!--                      class="roomCat-item-Txt"-->
<!--                      v-if="!isStateroomSoldout('BALCONY')"-->
<!--                    >-->
<!--                      人气推荐-->
<!--                    </div>-->
                    <div class="js_sailOut" v-else>
                      <i v-if="isConnectRoomMode">
                        <span>(售罄)</span>
                      </i>
                      <i v-else>
                        <span v-if="cruiseDetail.outOfStockEnable">(缺货登记)</span>
                        <span v-else>(售罄)</span>
                      </i>
                    </div>
                  </div>
                  <div
                    class="roomCat-item"
                    :class="{
                      active: currentStateroomType == 'DELUXE',
                      noactive: isStateroomSoldout('DELUXE'),
                    }"
                    @click="onStateroomTypeChanged('DELUXE')"
                  >
                    <div>套房</div>
                    <div class="js_sailOut" v-if="isStateroomSoldout('DELUXE')">
                      <i v-if="isConnectRoomMode">
                        <span>(售罄)</span>
                      </i>
                      <i v-else>
                        <span v-if="cruiseDetail.outOfStockEnable">(缺货登记)</span>
                        <span v-else>(售罄)</span>
                      </i>
                    </div>
                    <div class="room-tags" v-if="!isStateroomSoldout('DELUXE')">
                      <img :src="`${imgUrl}/mobile/details/room_tags_vip.png`"/>
                    </div>
                    <div v-if="currentSuiteType.id !== 'ALL'" class="room-type-switch"></div>
                  </div>
                </div>
              </div>
              <div class="packageDetail-roomCon">
                <div class="guest_room_content">
                  <div
                    class="room_cabin_content"
                    v-for="(stateroomType, i) in stateroomTypes"
                    :key="i"
                    :id="stateroomType"
                    :style="getStateroomListStyle(stateroomType)"
                  >
                    <div
                      class="room_cabin_list"
                      v-if="currentStateroomType == stateroomType"
                    >
                      <div v-if="!isConnectRoomMode">
                        <StateroomItem
                          v-for="(stateroom, index) in getStateroomList(
                            stateroomType
                          )"
                          v-show="isShowItem(stateroom)"
                          :suiteType="`${GlobalData.suiteTagStrValue[stateroom.suiteType]}_${stateroom.suiteType}`"
                          :key="getStateroomKey(stateroomType, stateroom, index)"
                          :id="getStateroomKey(stateroomType, stateroom, index)"
                          :allowUseTikTokCode="allowUseTikTokCode"
                          :shipCode="shipCode"
                          :sailDate="sailDate"
                          :packageCode="cruiseDetail.packageCode"
                          :nrpDefaultSelectedType="cruiseDetail.nrpDefaultSelectedType"
                          :stateroom="stateroom"
                          :guestNumber="currentGuestNumber"
                          :qiaohuGroup="qiaohuGroup"
                          :stateroomType="currentStateroomType"
                          :shoppingCarts="shoppingCarts"
                          :onShoppingCartAdd="onShoppingCartAdd"
                          :onShoppingCartDelete="onShoppingCartDelete"
                          :showStateroomDetail="showStateroomDetailPopup"
                          :showStateroomSuitePopup="showStateroomSuitePopup"
                          :showQiaohuPopup="showQiaohuPopup"
                          :showStarrySkyPopup="showStarrySkyPopup"
                          :showCustomThemePopup="showCustomThemePopup"
                          :isFortyEightHoursNrpCruise="
                            cruiseDetail.isFortyEightHoursNrpCruise
                          "
                        />
                      </div>
                      <div v-if="isConnectRoomMode">
                        <ConnectStateroomItem
                          v-for="(stateroom, index) in getConnectStateroom(
                            stateroomType
                          )"
                          v-show="isShowItemCon(stateroom)"
                          :suiteTypeFirsts="`${GlobalData.suiteTagStrValue[stateroom.connectStateroomFirsts.suiteType]}_${stateroom.connectStateroomFirsts.suiteType}`"
                          :suiteTypeSeconds="`${GlobalData.suiteTagStrValue[stateroom.connectStateroomSeconds.suiteType]}_${stateroom.connectStateroomSeconds.suiteType}`"
                          :key="getConnectStateroomKey(stateroom, index)"
                          :id="getConnectStateroomKey(stateroom, index)"
                          :allowUseTikTokCode="allowUseTikTokCode"
                          :shipCode="shipCode"
                          :sailDate="sailDate"
                          :packageCode="cruiseDetail.packageCode"
                          :nrpDefaultSelectedType="cruiseDetail.nrpDefaultSelectedType"
                          :connectStateroom="stateroom"
                          :stateroomType="currentStateroomType"
                          :shoppingCarts="shoppingCarts"
                          :onConnectShoppingCartAdd="onConnectShoppingCartAdd"
                          :onShoppingCartDelete="onShoppingCartDelete"
                          :showStateroomDetail="showStateroomDetailPopup"
                          :showStateroomSuitePopup="showStateroomSuitePopup"
                          :showConnectRoomPopup="showConnectRoomPopup"
                          :showQiaohuPopup="showQiaohuPopup"
                          :showStarrySkyPopup="showStarrySkyPopup"
                          :showCustomThemePopup="showCustomThemePopup"
                          :isFortyEightHoursNrpCruise="
                            cruiseDetail.isFortyEightHoursNrpCruise
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="room-noContent">来晚一步，这个房型已经被订完了～</div>

              <!-- 收起房型 按钮  start-->
              <template v-if="!isConnectRoomMode">
                <div class="folded-box" v-if="isShowFolded == true" @click="clickItem = !clickItem">
                  <div class="folded-box-text"> {{clickItem == true ? '收起全部房型':'展开查看全部房型'}}</div>
                  <template>
                    <img :class="[clickItem == true?'folded-box-text-img':'']" :src="currImgUrl+'toDownArrow.png'" alt="">
                  </template>
                </div>
              </template>
              <template v-else>
                <div class="folded-box" v-if="isShowFoldedCon == true" @click="clickItemCon = !clickItemCon">
                  <div class="folded-box-text"> {{clickItemCon == true ? '收起全部房型':'展开查看全部房型'}}</div>
                  <template>
                    <img :class="[clickItemCon == true?'folded-box-text-img':'']" :src="currImgUrl+'toDownArrow.png'" alt="">
                  </template>
                </div>
              </template>
              <!-- 收起房型 按钮  end-->

            </div>

            

          </div>
        </div>
        <div v-if="bannerIncludesBirthdayList && bannerIncludesBirthdayList.length > 0" class="specialBookingMobileBanner">
          <CustomBannerSwiper :bannerList="bannerIncludesBirthdayList" @on-jump="handleBannerToJump"></CustomBannerSwiper>
        </div>
        <div class="packageDetail-route" ref="routeContent">
          <div class="itemPackage">
            <div class="packageDetail-routeCon">
              <CruiseDetailFeatures ref="CruiseDetailFeatures" :featuresUrls="featuresUrls" />
              <div class="packageDetail-routeTop">
                <div class="packageDetail-routeTitle">
                  <img
                    src="https://resource.rcclchina.com.cn/mobileSearchPackage/routeAnchorIconB.png"
                  />
                  <span>行程概览</span>
                  <span class="route-tips">
                    目的地产品及行程可能因相关政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。
                  </span>
                </div>
                <div class="packageDetail-routeTitle-tips">
                  皇家加勒比游轮服务（中国）有限公司在法律允许的范围内对本行程保留解释权。
                </div>
              </div>
              <div class="packageDetail-routePlace">
                <div>
                  <div
                    class="packageDetail-routeItem"
                    v-for="(routeItem, i) in cruiseDetail.ports"
                    :key="'ports_' + i"
                  >
                    <div class="packageDetail-routePlane">
                      <span class="packageDetail-routePlane-order"
                        >第{{ routeItem.day }}天</span
                      >
                      <span class="packageDetail-routePlane-date">{{
                        routeItem.portDay
                      }}</span>
                      <span
                        v-if="i == 0 || i == cruiseDetail.ports.length - 1"
                        class="packageDetail-routeShip-icon packageDetail-routeShip-icon2"
                      >
                        <img
                          src="https://resource.rcclchina.com.cn/mobileSearchPackage/routeAnchorIcon.png"
                        />
                      </span>
                      <span
                        v-else-if="routeItem.code.indexOf('CRU') >= 0"
                        class="packageDetail-routeShip-icon"
                      >
                        <img
                          src="https://resource.rcclchina.com.cn/mobileSearchPackage/routeAnchorIcon.png"
                        />
                      </span>
                      <span v-else class="packageDetail-routeFlag-icon">
                        <img
                          src="https://resource.rcclchina.com.cn/mobileSearchPackage/routeFlagIcon.png"
                        />
                      </span>
                      <!-- routeTxt = "登船"; -->
                      <span class="packageDetail-routePlane-txt">{{
                        getRouteName(routeItem)
                      }}</span>
                    </div>
                    <div
                      class="packageDetail-routeItem-stay"
                      style="padding-bottom: 0px"
                      v-if="i == 0 || i == cruiseDetail.ports.length - 1"
                    >
                      {{ getRouteAddress(routeItem) }}
                    </div>
                    <div class="packageDetail-routeItem-stay">
                      {{ getRouteTime(routeItem) }}
                    </div>
                    <div class="packageDetail-routeItem-stay"></div>
                  </div>
                </div>
                <div class="packageDetail-routePlace-tip">
                  注：具体起航/抵港时间以实际行程为准。
                </div>
              </div>
            </div>
            <div
              class="packageDetail-routeDetail js-routeDetailBtn"
              @click="showRouteInfoPopup()"
            >
              <span>查看具体行程</span>
            </div>
          </div>
        </div>

        <div class="package-orderNotes" ref="bookingPolicyContent">
          <div class="package-orderNotesCon">
            <div class="package-orderNotes-top">
              <div class="package-orderNotes-title">
                <img
                  src="https://resource.rcclchina.com.cn/mobileSearchPackage/bellIcon.png"
                />
                <span>预订政策</span>
              </div>
            </div>
            <div class="orderNotesCon">
              <div class="itemPackage">
                <template v-for="item in policyListMenu">
                  <div :key="`policyMenuKey${item.id}`" class="package-orderNotes-category" v-if="isShowSpecialBooking!==item.hasBirthday">
                    <div
                      class="package-orderNotes-headline js-openNotesBtn"
                      @click="showBookingPolicyPopup(item.id)"
                    >
                      <div class="package-orderNotes-headline-l">
                        {{item.title}}
                      </div>
                      <div class="package-orderNotes-headline-r">
                        <img
                          src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightB.png"
                        />
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <HomeLikeRoute :likeRoutePopupsList="likeRoutePopupsList"
                       :isHomeShow="false"></HomeLikeRoute>

        <div
          class="package-travel"
          v-if="reviews && reviews.length > 0"
          ref="reviewContent"
        >
          <div class="package-travelTitle">
            <img
              src="https://resource.rcclchina.com.cn/mobileSearchPackage/cameraIcon.png"
            />
            <span>达人游记</span>
          </div>
          <div class="package-travelCon">
            <div class="itemPackage">
              <CruiseReviewItem
                v-for="(review, i) in reviews"
                :key="'review' + i"
                :review="review"
              />
            </div>
          </div>
        </div>
      </div>

      <div
          class="searchPackage-priceIcon js-ticketTips"
          @click="showTicketContainsPopup()"
      >
        船票<br />包含
      </div>
      <div
        class="searchPackage-priceIcon js-priceTips"
        @click="showCruisePriceInfo()"
        v-if="!isShowCruisePriceInfoPopup"
      >
        价格<br />说明
      </div>
      <div
        class="searchPackage-scrollTop js-scrollTopBtn"
        @click="scrollToTop()"
        ref="toScrollTop"
      >
        <img
          src="https://resource.rcclchina.com.cn/mobileSearchPackage/scrollTopIcon.png"
        />
      </div>

      <helperRomePopover 
        :shipCodeHelper="cruiseDetail.shipCode"
        :isShowDetail="isHelperRomePopoverShowDetail"
        @closeRoomDetailModel="isHelperRomePopoverShowDetail = false"
        :showStateroomSuitePopup="showSuiteTypeToSuiteDetails"
        />

      <CruiseShoppingCart
        v-if="shoppingCarts.length > 0"
        :isDownPayCruise="cruiseDetail.isDownPayCruise"
        :shipCode="shipCode"
        :sailDate="sailDate"
        :packageCode="cruiseDetail.packageCode"
        :shoppingCarts="shoppingCarts"
        :onShoppingCartDelete="onShoppingCartDelete"
        :showConnectRoomPopup="showConnectRoomPopup"
      />

      <SelectConnectStateroom
        v-if="isShowConnect"
        :onConnectClose="onConnectClose"
        :connectGuestCount="currentConnectGuestCount"
        :onConnectGuestSelected="onConnectGuestSelected"
        :showConnectRoomPopup="showConnectRoomPopup"
        :isOutOfStock="getCruiseOutOfStock()"
      />

      <StateroomSuitePopup
        :suiteImage="suiteImage"
        :onGoBack="closeStateroomSuitePopup"
        :isShow="isShowSuitePopup"
      />

      <QiaohuPopup
        :shipCode="shipCode"
        :sailDate="sailDate"
        :onGoBack="closeQiaohuPopup"
        :isShow="isShowQiaohuPopup"
      />

      <StarrySkyPopup
          :shipCode="shipCode"
          :sailDate="sailDate"
          :onGoBack="closeStarrySkyPopup"
          :isShow="isShowStarrySkyPopup"
      />

      <CustomThemePopup
          :onGoBack="closeCustomThemePopup"
          :isShow="isShowCustomThemePopup"
          :themeInfo="personalizedStateroomInfo"
      />

      <ConnectRoomPopup
        :onGoBack="closeConnectRoomPopup"
        :isShow="isShowConnectRoomPopup"
      />

      <CancelPolicy
        :onGoBack="closeCancelPolicyPopup"
        :isShow="isShowCancelPolicyPopup"
        :isFortyEightHoursNrpCruise="cruiseDetail.isFortyEightHoursNrpCruise"
      />

      <CruisePriceInfo
        :onGoBack="closeCruisePriceInfo"
        :isShow="isShowCruisePriceInfoPopup"
      />

      <StateroomDetail
        :onGoBack="closeStateroomDetailPopup"
        :isShow="isShowStateroomDetailPopup"
        :stateroomDetail="selectStateroom"
        :shipCode="cruiseDetail.shipCode"
        :isFortyEightHoursNrpCruise="cruiseDetail.isFortyEightHoursNrpCruise"
      />

      <RouteInfoPopup
        :onGoBack="closeRouteInfoPopup"
        :isShow="isShowRouteInfoPopup"
        :routeEvents="cruiseDetail.ports"
        :shipCode="shipCode"
        :showShorexPopup="showShorexPopup"
      />

      <ShorexInfoPopup
        :onGoBack="closeShorexPopup"
        :isShow="isShowShorexPopup"
        :shorexInfo="shorexInfo"
      />

      <BookingPolicyPopup
        :onGoBack="closeBookingPolicyPopup"
        :isShow="isShowBookingPolicyPopup"
        :visaContent="cruiseDetail.visaContent"
        :isFortyEightHoursNrpCruise="cruiseDetail.isFortyEightHoursNrpCruise"
        :isSevenDayNrpCruise="cruiseDetail.isSevenDayNrpCruise"
        :departureCode="departureCode"
        :showBankPopup="showBankPopup"
        :currentTab="currentPolicyTab"
        :isShowSpecialBooking="isShowSpecialBooking"
        :shipCode="shipCode"
        :sailDate="sailDate"
        :isDownPayCruise="cruiseDetail.isDownPayCruise"
        :showRow="false"
      />

      <BankPopup :onGoBack="closeBankPopup" :isShow="isShowBankPopup" />

      <CruiseCoupon
        :coupons="coupons"
        :isShow="isShowCruiseCoupon"
        :closeCruiseCoupon="closeCruiseCoupon"
        :onCouponRuleClick="showCouponRule"
        :setCouponRecieved="setCouponRecieved"
      />

      <CouponRulePopup
        :couponRule="couponRule"
        :isShow="isShowCouponRule"
        :closeCouponRule="closeCouponRule"
      />

      <CruiseTagPopup
        :tags="tags"
        :isShow="isShowCruiseTagPopup"
        :onGoBack="closeCruiseTagPopup"
      />

      <TicketContainsPopup :tags="tags"
                           :isShow="isShowTicketContainsPopup"
                           :onGoBack="closeTicketContainsPopup"></TicketContainsPopup>

      <SuiteIntroducePopup :isShow="isShowSuiteIntroducePopup"
                           :suiteImage="cruiseDetail.suiteImageMB"
                           :onGoBack="closeSuiteIntroducePopup"></SuiteIntroducePopup>

      <SpecialBookingRuleImagePopup
        :specialRuleImage="specialBookingRuleImage"
        :closeSpecialBookingPopup="closeSpecialBookingPopup"
        v-show="isShowSpecialBookingRuleImagePopup"
        :specialName="specialBookingName"
        :isShowSpecialBooking="isShowSpecialBooking"
      />
    </div>

    <EmergencyMessageAlert />

    <SuiteTypeSelectModel :is-show="isShowSuiteTypeSelect"
                          :suite-type="currentSuiteType"
                          :disable-list="disableSuiteTypeList"
                          :shipCode="cruiseDetail.shipCode"
                          @close="suiteTypeSelectModelClose"
                          @change="suiteTypeSelectModelChange"
                          @details-popup="showSuiteTypeToSuiteDetails"></SuiteTypeSelectModel>
    <BottomPopup :show="isShowOutOfStockPopup"
                 title="缺货登记"
                 @close="closeOutOfStockPopup">
      <div class="outOfStock-con" v-if="outOfStockRoom">
        <div class="outOfStock-title">该舱房类型暂时售罄，推荐您预订同款或临近航线</div>
        <div class="recommendedRoute-list">

          <home-like-route :likeRoutePopupsList="outOfStockCruiseList" :type="2"
                           :isOutOfStock="true" :stateroomType="stateroomType"
                           :guestNumberCount="guestNumberCount">
          </home-like-route>
        </div>
        <div class="outOfStock-title">仍需缺货登记</div>
        <div class="outOfStock-roomName">
          您登记的缺货房型为：
          <div class="roomName">
            {{roomName}}
          </div>
        </div>
        <div class="outOfStock-selectRoom" v-if="!hideSelectRoom">
          <div class="outOfStock-roomName">请选择您的偏好：</div>
          <div class="selectRoom-main">
            <div class="selectRoom-item"
                 :class="{'active':i.isActive}"
                 v-for="(i,idx) in outOfStockRoom"
                 :key="idx" @click="changeOutOfStockRoom(i,idx)">
              {{i.typeName}}
            </div>
          </div>
        </div>
        <div v-if="!isHaveRegistered" class="confirmBtn" @click="submitOutOfStock">确认登记</div>
        <div v-else class="haveRegistered">已登记</div>
        <div class="outOfStock-tips">有舱后将以短信及微信消息的形式通知您</div>
      </div>
      <div v-if="isShowNullRoomTips" class="noSelectRoomTips" >
        <div class="tips-text">
          请选择您偏好的房型后再提交
        </div>
      </div>
    </BottomPopup>

    
  </div>
</template>

<script>
import {directive} from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import api from "@/api";
import _ from "lodash";
import {createUserBrowsingRecord, gioTracking, isEmpty, isHkSpecialCruise, pageScroll, updateCountdown} from "@/utilities/tools"
import wechatHelper from "@/utilities/wechatHelper";
import {SpecialBookingType} from "@/utilities/specialBookingHelper";
import StarrySkyPopup from "@/components/Cruise/StarrySkyPopup.vue";
import BottomPopup from "@/components/Booking/BottomPopup.vue";
import CustomBannerSwiper from "@/components/Common/CustomBannerSwiper.vue";

const StateroomItem = () => import("@/components/Cruise/StateroomItem");
const ConnectStateroomItem = () => import("@/components/Cruise/ConnectStateroomItem");
const CruiseShoppingCart = () => import("@/components/Cruise/CruiseShoppingCart");
const SelectConnectStateroom = () => import("@/components/Cruise/SelectConnectStateroom");
const CruiseReviewItem = () => import("@/components/Cruise/CruiseReviewItem");
const StateroomSuitePopup = () => import("@/components/Cruise/StateroomSuitePopup");
const QiaohuPopup = () => import("@/components/Cruise/QiaohuPopup");
const ConnectRoomPopup = () => import("@/components/Cruise/ConnectRoomPopup");
const CancelPolicy = () => import("@/components/Cruise/CancelPolicy");
const StateroomDetail = () => import("@/components/Booking/StateroomDetail");
const CruisePriceInfo = () => import("@/components/Cruise/CruisePriceInfo");
const RouteInfoPopup = () => import("@/components/Cruise/RouteInfoPopup");
const ShorexInfoPopup = () => import("@/components/Cruise/ShorexInfoPopup");
const BookingPolicyPopup = () => import("@/components/Cruise/BookingPolicyPopup");
const BankPopup = () => import("@/components/Booking/BankPopup");
const CruiseCoupon = () => import("@/components/Cruise/CruiseCoupon");
const CouponRulePopup = () => import("@/components/Cruise/CouponRulePopup");
const CruiseTagPopup = () => import("@/components/Cruise/CruiseTagPopup");
const EmergencyMessageAlert = () => import("@/components/Home/EmergencyMessageAlert");
const SpecialBookingRuleImagePopup = () => import("@/components/Cruise/SpecialBookingRuleImagePopup");
const TicketContainsPopup = () => import("@/components/Cruise/TicketContainsPopup");
const SuiteIntroducePopup = () => import("@/components/Cruise/SuiteIntroducePopup");
const CruiseDetailFeatures = () => import("@/components/Cruise/CruiseDetailFeatures");
const SuiteTypeSelectModel = () => import("@/components/Cruise/SuiteTypeSelectModel");
const HomeLikeRoute = () => import("@/components/Home/HomeLikeRoute");
const CustomThemePopup = () => import("@/components/Cruise/CustomThemePopup.vue");
const helperRomePopover = () => import("@/components/Cruise/helperRomePopover");
const uCountDown = ()=> import("@/components/Cruise/uCountDown.vue");
export default {
  name: "CruiseDetail",
  components: {
    CustomBannerSwiper,
    BottomPopup,
    StarrySkyPopup,
    StateroomItem,
    ConnectStateroomItem,
    CruiseShoppingCart,
    SelectConnectStateroom,
    CruiseReviewItem,
    StateroomSuitePopup,
    QiaohuPopup,
    ConnectRoomPopup,
    CancelPolicy,
    StateroomDetail,
    CruisePriceInfo,
    RouteInfoPopup,
    ShorexInfoPopup,
    BookingPolicyPopup,
    BankPopup,
    CruiseCoupon,
    CouponRulePopup,
    CruiseTagPopup,
    EmergencyMessageAlert,
    SpecialBookingRuleImagePopup,
    TicketContainsPopup,
    CruiseDetailFeatures,
    SuiteTypeSelectModel,
    SuiteIntroducePopup,
    HomeLikeRoute,
    CustomThemePopup,
    helperRomePopover,
    uCountDown
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      tenSecondDoFn:false,
      timerScroll:null,
      currImgUrl: process.env.VUE_APP_IMG_URL + '/wechatMiniProgram/routesDetail/housingSelection/',
      imgUrl: process.env.VUE_APP_IMG_URL,
      swiperOption: {
        autoplay: {
          delay: 5000,
        },
        loop: true,
        on: {
          slideChangeTransitionEnd: this.onBannerSliderChange,
        },
      },
      bannerIndex: 1,
      isNavFixed: false,
      navIndex: 0,
      isPPP: false,
      currentGuestNumber: 2,
      currentStateroomType: "INTERIOR",
      stateroomCategories: [],
      currentConnectGuestCount: "",
      isShowConnect: false,
      shoppingCarts: [],
      coupons: [],
      isInWishList: false,
      collections: 0,
      suiteImage: "",
      selectStateroom: {
        stateroomImages: [],
        stateroomName: "",
        stateroomCategory: "",
        stateroomPriceType: "",
        stateroomPrice: 0,
        stateroomCapacity: "",
        stateroomArea: "",
        stateroomBalcony: "",
        stateroomFloor: "",
        isQiaohu: false,
        stateroomDescription: "",
        stateroomNrpTitle: "",
        stateroomNrpText: "",
        suiteMobileImageUrl: "",
        deviceGroupTags: []
      },
      shorexInfo: {
        freeShorex: [],
        payShorex: [],
      },
      reviews: [],
      currentPolicyTab: 0,
      isShowSuitePopup: false,
      isShowQiaohuPopup: false,
      isShowStarrySkyPopup: false,
      isShowConnectRoomPopup: false,
      isShowCancelPolicyPopup: false,
      isShowStateroomDetailPopup: false,
      isShowCruisePriceInfoPopup: false,
      isShowRouteInfoPopup: false,
      isShowShorexPopup: false,
      isShowBookingPolicyPopup: false,
      isShowBankPopup: false,
      isShowCruiseCoupon: false,
      isShowCouponRule: false,
      isShowCruiseTagPopup: false,
      isShowTicketContainsPopup: false,
      couponRule: "",
      isShowSpecialBookingRuleImagePopup: false,
      featuresUrls: [],
      isShowSuiteTypeSelect: false,
      currentSuiteType: {
        id: 'ALL',
        title: '全部',
        type: null,
        isSelected: true
      },
      disableSuiteTypeList: [],
      isShowSuiteIntroducePopup: false,
      suiteTypeRooms: [],
      allowUseTikTokCode: false,
      cruiseId: null,
      likeRoutePopupsList:[],
      policyListMenu: [],
      policyContentList:[],
      vrUrl:'',
      isShowOutOfStockPopup:false, // 缺货弹窗
      outOfStockRoom: null,  // 缺货信息
      outOfStockCruiseList: null, // 缺货舱房信息
      outOfStockIds:[],
      isShowNullRoomTips:false,
      isHaveRegistered:false,
      roomName:'',
      hideSelectRoom:false, // 选择房间显示
      guestNumberCount:0,
      cabinRoomType:'',
      isConnectGuestRoom:false,
      stateroomType:'',
      cruiseCampaign:{},
      isShowCustomThemePopup: false,
      personalizedStateroomInfo: null,
      clickItem:false,
      clickItemCon:false,
      isHelperRomePopoverShowDetail:false,
      isLoading:false,
      bannerIncludesBirthdayList: [], //banner含生日
      bannerIncludesBirthdayLoadedKey: '' //banner请求防重key（shipCode_sailDate），避免created+activated双调用重复请求
    };
  },
  asyncData({ store, route, component }) {
    const shipCode = route.query.shipCode;
    const sailDate = route.query.sailDate;
    const userToken = store.state.user.userToken;
    return new Promise((resolve, reject) => {
      if (component.$loading) {
        component.$loading.show();
      }
      store.commit("SET_CRUISE_DETAIL_SAILING", { shipCode, sailDate });
      return api.cruise
        .getCruiseDetail({
          shipCode: shipCode,
          sailDate: sailDate,
          username: userToken,
          tagSource: "mobile",
        })
        .then(({ success, data, errMsg }) => {
          if (!success) console.error(errMsg);
          store.commit("SET_CRUISE_DETAIL", { success, data });
          createUserBrowsingRecord({
            ProductType: 3,
            ProductId: data.cruiseId,
            SceneType: 1,
            Parameters: []
          });
          if (data.seoViewModel) {
            store.commit("SET_META", data.seoViewModel);
          }
          // component.checkTikTokCampaignCode();
          resolve();
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  props: {},

  activated() {
    this.getRouteDetailYouLike()
    const shipCode = this.$router.currentRoute.query.shipCode;
    const sailDate = this.$router.currentRoute.query.sailDate;
    this.getWishListStatus();
    this.getBannerIncludesBirthdayList();

    // 每次进入往sessionStorage存shipCode和sailDate
    let recentlyViewed = {
      shipCode:shipCode,
      sailDate:sailDate
    }
    localStorage.setItem('recentlyViewed',JSON.stringify(recentlyViewed))

    const self = this;
    window.onpopstate = () => {
      if (self.isShowCancelPolicyPopup) {
        self.closeCancelPolicyPopup();
      }
      if (self.isShowSuitePopup) {
        self.closeStateroomSuitePopup();
      }
      if (self.isShowQiaohuPopup) {
        self.closeQiaohuPopup();
      }
      if (self.isShowStarrySkyPopup) {
        self.closeStarrySkyPopup();
      }
      if (self.isShowConnectRoomPopup) {
        self.closeConnectRoomPopup();
      }
      if (self.isShowStateroomDetailPopup) {
        self.closeStateroomDetailPopup();
      }
      if (self.isShowCruisePriceInfoPopup) {
        self.closeCruisePriceInfo();
      }

      if (self.isShowShorexPopup) {
        self.closeShorexPopup();
      } else if (self.isShowRouteInfoPopup) {
        self.closeRouteInfoPopup();
      }

      if (self.isShowBankPopup) {
        self.closeBankPopup();
      } else if (self.isShowBookingPolicyPopup) {
        self.closeBookingPolicyPopup();
      }
      if (self.isShowCouponRule) {
        self.closeCouponRule();
      }

      if (self.isShowCruiseTagPopup) {
        self.closeCruiseTagPopup();
      }
    };

    

    window.addEventListener("scroll", function () {
      self.pageScrollHandler(window.scrollY);
    });
    self.pageScrollHandler(window.scrollY);
    this.getShipVrMiniSite()

    
  },
  deactivated() {
    window.onpopstate = () => {};
  },
  beforeMount() {
    this.getCruiseCampaignInfo();
    
  },
  beforeDestroy() {
    if (this.countDownTimer) {
      clearInterval(this.countDownTimer);
    }
  },
  created(){
    this.getAllCruiseFeature()
    this.policyListMenu = this.GlobalData.policyListMenu;

    this.getShoppingCart();
    this.getBannerIncludesBirthdayList();
  },
  methods: {
    // 判断十秒内没有操作
    openHelpFn(){
      
      // 每次进入页面 只弹出一次
      if(this.tenSecondDoFn) return clearTimeout(this.timerScroll);
      
      
      // 有弹框的情况下不执行
      if(!this.isShowSuitePopup 
      && !this.isShowQiaohuPopup
      && !this.isShowStarrySkyPopup
      && !this.isShowConnectRoomPopup
      && !this.isShowStateroomDetailPopup
      && !this.isShowCruisePriceInfoPopup
      && !this.isShowShorexPopup
      && !this.isShowRouteInfoPopup
      && !this.isShowBankPopup
      && !this.isShowBookingPolicyPopup
      && !this.isShowCouponRule
      && !this.isShowCruiseTagPopup
      && !this.isShowTicketContainsPopup
      && !this.isShowNullRoomTips
      && !this.isShowOutOfStockPopup
      && !this.isShowCruiseCoupon
      && !this.isShowCruiseTagPopup
      ){
        this.tenSecondDoFn = true
        console.log('openHelpFn 执行')
        // 显示弹框
        this.isHelperRomePopoverShowDetail = true
        clearTimeout(this.timerScroll);
      }else{ 
        this.startTimer()
      }
    },
    startTimer() {
      // 每次进入页面 只弹出一次
      if(this.tenSecondDoFn) return clearTimeout(this.timerScroll);

      if(this.timerScroll){
        clearTimeout(this.timerScroll); // 清除之前的定时器，以防万一
        this.tenSecondDoFun()
      }else{
        this.tenSecondDoFun()
      }
      
    },
    tenSecondDoFun(){
      this.timerScroll = setTimeout(() => {
            this.openHelpFn();
            // 这里可以执行没有操作的逻辑
        }, 30000); // 30秒后触发
    },
    async getAllCruiseFeature(){
      const { success,data,errMsg } = await api.cruise.getAllCruiseFeature();
      if(success) {
        this.featuresUrls = data;
      } else {
        this.$alert.show(errMsg);
      }
    },
    
    onBannerSliderChange() {
      if (this.bannerSwiper) {
        document.getElementById("cruiseDetailBannerIndex").innerHTML =
          this.bannerSwiper.realIndex + 1;
      }
    },
    // 调用获取舱房接口
    async getStateroomCategory() {
      if(this.isLoading) return;
      let guestNumbers = [];
      for (let i = 0; i < this.currentGuestNumber; i++) {
        guestNumbers.push(30);
      }
      let tikTokCode = "";
      if(!isEmpty(sessionStorage.getItem("tikTokCode"))) {
        tikTokCode = sessionStorage.getItem("tikTokCode");
      }
      let requestData = {
        userName: this.$store.state.user.userToken,
        viewModel: {
          guestAges: guestNumbers,
          shipCode: this.shipCode,
          sailDate: this.sailDate,
          packageId: this.cruiseDetail.packageCode,
          agencyId: this.agencyId,
          currency: "CNY",
          connectGuestCount: this.currentConnectGuestCount,
          tikTokCouponCode: tikTokCode
        }
      };
      if (this.qiaohuGroup.groupId && this.qiaohuGroup.groupId.length > 0) {
        requestData.viewModel.isGroup = true;
        requestData.viewModel.groupId = this.qiaohuGroup.groupId;
        requestData.viewModel.groupType = this.qiaohuGroup.groupType;
      }
      this.isLoading = true;
      try {
        this.$loading.show();
        const { success, data, errMsg } = await api.cruise.getStateroomCategory(
          requestData
        );
        if (!success) {
          this.stateroomCategories = [];
          console.error(errMsg);
        } else {
          const staterooms = data || [];
            //从接口中重置 currentGuestNumber currentConnectGuestCount值
          if (staterooms?.length > 0) {
            const categoriesItem = staterooms[0]
               
            // 连通房
            if (categoriesItem.connectGuestCount?.length > 0) {
              this.currentConnectGuestCount=categoriesItem.connectGuestCount
              this.currentGuestNumber = 0    
            } else {
              // 普通房间
              this.currentGuestNumber = categoriesItem.guestAges?.length
              this.currentConnectGuestCount = "";
            }
          } 

          this.stateroomCategories = data;
          this.getStateroomSuccessHandler();
        }
        this.$loading.hide();
        this.isLoading = false;
      } catch (error) {
        this.stateroomCategories = [];
        this.$loading.hide();
        this.isLoading = false;
        console.error('获取舱房失败',error);
      }
 
    },
    // 获取舱房成功后，查找可用的舱房类型
    getStateroomSuccessHandler() {
      if (!this.stateroomCategories || this.stateroomCategories.length == 0) {
        this.currentStateroomType = "";
        return;
      }
      if (this.isConnectRoomMode) {
        const staterooms = _.orderBy(this.stateroomCategories, "lowestPrice");
        this.currentStateroomType = staterooms[0].stateroomType;
      } else {
        const staterooms = this.stateroomCategories.filter(
          (r) =>
            r.stateroomCategoriesItems && r.stateroomCategoriesItems.length > 0
        );
        let stateroomType = "";
        let lowestPrice = 999999999;
        staterooms.forEach((stateroom) => {
          stateroom.stateroomCategoriesItems.forEach((stateroomCategory) => {
            if (stateroomCategory.netAmount < lowestPrice) {
              lowestPrice = stateroomCategory.netAmount;
              stateroomType = stateroom.stateroomType;
            }
          });
        });
        this.currentStateroomType = stateroomType;
      }
    },
    async getCruiseReviews() {
      let request = {
        shipCode: this.shipCode,
        sailDate: this.sailDate,
      };
      const { data } = await api.cruise.getCruiseReview(request);
      if (data && data.length > 0) {
        this.reviews = data;
      }
    },
    onGuestNumberChange(number) {
      if(this.isLoading) return;
      this.isConnectGuestRoom = false
      this.currentGuestNumber = number;
      this.suiteTypeMenuInit();
      if (this.currentConnectGuestCount.length > 0) {
        this.currentConnectGuestCount = "";
        this.$refs.roomNav.scrollLeft = 0;
      }
      this.getStateroomCategory();
      gioTracking("track", "evt_GuestCount", {
        GuestNumber: number + "",
        shipCode:this.shipCode,
        sailDate:this.sailDate
      });

      // 收起按钮 关闭
      this.clickItem = false;
      this.clickItemCon = false;
    },
    getConnectStateroom(stateroomType) {
      let connectStateroomItems = [];
      if (!this.stateroomCategories || this.stateroomCategories.length == 0) {
        return connectStateroomItems;
      }
      const staterooms = this.stateroomCategories.filter(
        (r) =>
          r.stateroomType == stateroomType &&
          r.connectStateroomFirsts &&
          r.connectStateroomFirsts.length > 0 &&
          r.connectStateroomSeconds &&
          r.connectStateroomSeconds.length > 0
      );
      if (staterooms.length == 0) {
        return connectStateroomItems;
      }
      staterooms.forEach((connectRooms) => {
        const first = this.getConnectRoomPrice(
          connectRooms.connectStateroomFirsts
        );
        const second = this.getConnectRoomPrice(
          connectRooms.connectStateroomSeconds
        );

        const connectId = connectRooms.connectId;
        connectStateroomItems.push({
          connectStateroomFirsts: first,
          connectStateroomSeconds: second,
          isFolded:first.isFolded == true || second.isFolded == true ? true : false,
          connectId,
        });
      });
      return connectStateroomItems;
    },
    getConnectRoomPrice(connectStaterooms) {
      let stateroom = connectStaterooms[0];
      stateroom.price = [
        {
          originalAmount: stateroom.originalAmount,
          portCharges: stateroom.portCharges,
          netAmount: stateroom.netAmount,
          isnrp: stateroom.isnrp,
          fareCode: stateroom.selectedFareCode,
          amountPerNight: (stateroom.netAmount/stateroom.guestNumber) / (this.cruiseDetail.sailDays - 1),
          perPeopleAmount: stateroom.perPeopleAmount,
          perNightAmount: stateroom.perNightAmount
        },
      ];
      if (connectStaterooms.length > 1) {
        const stateroom2 = connectStaterooms[1];
        stateroom.price.push({
          originalAmount: stateroom2.originalAmount,
          portCharges: stateroom2.portCharges,
          netAmount: stateroom2.netAmount,
          isnrp: stateroom2.isnrp,
          fareCode: stateroom2.selectedFareCode,
          amountPerNight: (stateroom2.netAmount/stateroom2.guestNumber) / (this.cruiseDetail.sailDays - 1),
          perPeopleAmount: stateroom2.perPeopleAmount,
          perNightAmount: stateroom2.perNightAmount
        });
      }
      return stateroom;
    },
    async getRouteDetailYouLike() {
      // let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'))

      let shipCode =  this.$route.query.shipCode;
      let sailDate =  this.$route.query.sailDate;
      // if(recentlyViewed){
      //   shipCode = recentlyViewed.shipCode;
      //   sailDate = recentlyViewed.sailDate;
      // }
      const { data ,success} = await api.booking.getRouteDetailYouLike({
        shipCode:shipCode,
        sailDate:sailDate
      });
      if(success===true && data!==null){
          this.likeRoutePopupsList = data.cruises
      }
    },
    getStateroomList(stateroomType) {
      let stateroomItems = [];
      const staterooms = this.stateroomCategories.filter(
        (r) => {return r.stateroomType == stateroomType}
      );

      if (
        staterooms.length == 0 ||
        !staterooms[0].stateroomCategoriesItems ||
        staterooms[0].stateroomCategoriesItems.length == 0
      ) {
        return [];
      }
      staterooms[0].stateroomCategoriesItems.forEach((stateroom) => {
        let stateroomItem = stateroomItems.filter(
          (r) => r.stateroomCategoryCode == stateroom.stateroomCategoryCode
        );
        if (!stateroomItem || stateroomItem.length == 0) {
          stateroom.price = [
            {
              originalAmount: stateroom.originalAmount,
              portCharges: stateroom.portCharges,
              netAmount: stateroom.netAmount,
              isnrp: stateroom.isnrp,
              fareCode: stateroom.selectedFareCode,
              amountPerNight: (stateroom.netAmount/this.currentGuestNumber) / (this.cruiseDetail.sailDays - 1),
              perPeopleAmount: stateroom.perPeopleAmount,
              perNightAmount: stateroom.perNightAmount
            },
          ];
          stateroomItems.push(stateroom);
        } else {
          stateroomItem[0].price.push({
            originalAmount: stateroom.originalAmount,
            portCharges: stateroom.portCharges,
            netAmount: stateroom.netAmount,
            isnrp: stateroom.isnrp,
            fareCode: stateroom.selectedFareCode,
            amountPerNight: (stateroom.netAmount/this.currentGuestNumber) / (this.cruiseDetail.sailDays - 1),
            perPeopleAmount: stateroom.perPeopleAmount,
            perNightAmount: stateroom.perNightAmount
          });
        }
      });
      // console.log('stateroomItems',stateroomItems)
      return stateroomItems;
    },
    isStateroomSoldout(stateroomType) {
      if(stateroomType === 'DELUXE' && !isEmpty(sessionStorage.getItem("tikTokCode"))) {
        return true;
      }
      if (!this.stateroomCategories || this.stateroomCategories.length == 0) {
        return true;
      }
      if (this.isConnectRoomMode) {
        return !this.stateroomCategories.some(
          (r) =>
            r.stateroomType == stateroomType &&
            r.connectStateroomFirsts &&
            r.connectStateroomFirsts.length > 0 &&
            r.connectStateroomSeconds &&
            r.connectStateroomSeconds.length > 0
        );
      } else {
        return !this.stateroomCategories.some(
          (r) =>
            r.stateroomType == stateroomType &&
            r.stateroomCategoriesItems &&
            r.stateroomCategoriesItems.length > 0
        );
      }
    },
    checkHasQHRoom(guestNumber) {
      if (guestNumber == 3) {
        return this.cruiseDetail.qH_Gruest3_Stock > 0;
      } else if (guestNumber == 4) {
        return this.cruiseDetail.qH_Gruest4_Stock > 0;
      }
      return false;
    },
    onStateroomTypeChanged(stateroomType) {
      if(stateroomType === 'DELUXE' && !this.isStateroomSoldout('DELUXE')) {
          let stateroomList = !this.isConnectRoomMode ? this.getStateroomList(stateroomType) : this.getConnectStateroom(stateroomType);
          let disableSuiteTypeList = [];
          if(this.isConnectRoomMode) {
            stateroomList && stateroomList.forEach((r)=> {
              disableSuiteTypeList.push(r.connectStateroomFirsts.suiteType);
              disableSuiteTypeList.push(r.connectStateroomSeconds.suiteType);
            });
          } else {
            stateroomList && stateroomList.forEach((r)=> {
              disableSuiteTypeList.push(r.suiteType)
            });
          }
          this.disableSuiteTypeList = Array.from(new Set(disableSuiteTypeList));
          this.isShowSuiteTypeSelect = true;
      } else {
        this.suiteTypeMenuInit();
      }
      if (!this.isStateroomSoldout(stateroomType)) {
        this.currentStateroomType = stateroomType;
				gioTracking('track', 'evt_RoomClass', {
					'RoomClass': stateroomType,
          'shipCode':this.shipCode,
          'sailDate':this.sailDate
				})
      }else{
        if(this.isConnectRoomMode) return
        this.getOutOfStockInfo(stateroomType)
      }

      // 收起按钮 关闭
      this.clickItem = false;
      this.clickItemCon = false;
    },
    suiteTypeSelectModelClose(val) {
      this.isShowSuiteTypeSelect = val;
      this.setSuiteTypeSelectModel(this.currentSuiteType);
    },
    suiteTypeSelectModelChange(val) {
      this.isShowSuiteTypeSelect = false;
      this.setSuiteTypeSelectModel(val);
    },
    setSuiteTypeSelectModel(val) {
      let currSuiteType = val.id +'_'+ val.type;
      this.currentSuiteType = val;
      let deluxeObj = document.getElementById('DELUXE');
      let roomCabinDetail = deluxeObj.getElementsByClassName("room_cabin_detail");
      // isConnectRoomMode suiteTypeSeconds suiteTypeFirsts
      for(let i = 0; i < roomCabinDetail.length; i++) {
        let roomObj = roomCabinDetail[i];
        if(this.isConnectRoomMode) {
          let suiteTypeFirsts = roomObj.getAttribute('suiteTypeFirsts');
          let suiteTypeSeconds = roomObj.getAttribute('suiteTypeSeconds');
          if(val.id === "ALL" || (currSuiteType === suiteTypeFirsts || currSuiteType === suiteTypeSeconds)) {
            roomObj.style.display = 'block'
          } else {
            roomObj.style.display = 'none'
          }
        } else {
          let suiteType = roomObj.getAttribute('suiteType');
          if(val.id === "ALL" || currSuiteType === suiteType) {
            roomObj.style.display = 'block'
          } else {
            roomObj.style.display = 'none'
          }
        }
      }
    },
    getStateroomListStyle(stateroomType) {
      return this.currentStateroomType == stateroomType
        ? { display: "block" }
        : {};
    },
    onCruiseCalendarClick() {
      this.$router.push({
        name: "CruiseCalendar",
        query: {
          shipCode: this.shipCode,
          sailDate: this.sailDate,
          routeCode: this.cruiseDetail.routeName,
        },
      });
    },
    async getWishListStatus() {
      const userToken = this.$store.state.user.userToken;
      const { data } = await api.cruise.isInWishList({
        userName: userToken,
        cruiseId: this.cruiseDetail.cruiseId,
      });
      if (data) {
        this.isInWishList = data.inWishList;
        this.collections = data.collections;
      }
    },
    onWishListClick() {
      if (this.isInWishList) {
        this.deleteWishList();
      } else {
        this.addWishList();
      }
    },
    async addWishList() {
      const userToken = this.$store.state.user.userToken;
      if (!userToken || userToken.length == 0) {
        let self = this;
        this.$confirm.show("您尚未登录， 请登录之后， 再添加至心愿单", {
          confirmCallBack: () => {
            self.$router.push({
              name: "Login",
              query: {
                returnUrl: location.href,
              },
            });
          },
        });
        return;
      }
      const requestData = {
        userName: userToken,
        cruiseId: this.cruiseDetail.cruiseId,
        source: "mobile",
      };
      this.$loading.show();
      const { success } = await api.cruise.addWishList(requestData);
      if (success) {
        this.isInWishList = true;
        this.collections++;
      }
      this.$loading.hide();
    },
    async deleteWishList() {
      const userToken = this.$store.state.user.userToken;
      if (!userToken || userToken.length == 0) {
        let self = this;
        this.$confirm.show("您尚未登录， 请登录之后， 再添加至心愿单", {
          confirmCallBack: () => {
            self.$router.push({
              name: "Login",
              query: {
                returnUrl: location.href,
              },
            });
          },
        });
        return;
      }
      const requestData = {
        userName: userToken,
        cruiseId: this.cruiseDetail.cruiseId,
        source: "mobile",
      };
      this.$loading.show();
      const { success } = await api.cruise.deleteWishList(requestData);
      if (success) {
        this.isInWishList = false;
        if (this.collections > 0) {
          this.collections--;
        }
      }
      this.$loading.hide();
    },
    async onShoppingCartAdd(stateroomData) {
      // 选房助手 10秒弹出 取消
      this.tenSecondDoFn = true

      if (!this.userToken || this.userToken.length == 0) {
        let self = this;
        this.$confirm.show("您尚未登录， 请登录之后， 再添加舱房", {
          confirmCallBack: () => {
            self.$router.push({
              name: "Login",
              query: {
                returnUrl: location.href,
              },
            });
          },
        });
        return;
      }
      try {
        if (window.gio && stateroomData.isNrp) {
          window.gio("track", "NRP_BF01");
        }
      } catch (e) {
        console.error(e);
      }
      let requestData = {
        viewModel: stateroomData,
      };
      this.$loading.show();
      const { success, errMsg } = await api.booking.addShoppingCart(
        requestData
      );
      if (!success) {
        this.$alert.show(errMsg);
      }
      this.getShoppingCart();
      this.$loading.hide();
    },
    async onShoppingCartDelete(stateroomData) {
      if (!this.userToken || this.userToken.length == 0) {
        let self = this;
        this.$confirm.show("您尚未登录， 请登录之后， 再添加舱房", {
          confirmCallBack() {
            self.$router.push({
              name: "Login",
              query: {
                returnUrl: location.href,
              },
            });
          },
        });
        return;
      }
      let requestData = {
        viewModel: stateroomData,
      };

      try {
        if (window.gio && requestData.viewModel.isNrp) {
          window.gio("track", "NRP_BF01");
        }
      } catch (e) {
        console.error(e);
      }

      this.$loading.show();
      const { success, errMsg } = await api.booking.deleteShoppingCart(
        requestData
      );
      if (!success) {
        console.error(errMsg);
        // this.$alert.show(errMsg)
      }
      this.$loading.hide();
      this.getShoppingCart();
    },
    async getShoppingCart() {
      this.$loading.show();
      const userToken = this.$store.state.user.userToken;
      if (userToken && userToken.length > 0) {
        const { data } = await api.booking.getShoppingCart({
          type: 0,
          userName: userToken,
        });
        if (data) {
          if (!data.bookings) {
            data.bookings = [];
          }
          this.shoppingCarts = data.bookings.filter(
            (r) => r.shipCode == this.shipCode && r.sailDate == this.sailDate
          );
          this.$store.dispatch("GET_SHOPPING_CART_COUNT");
        }
      }
      this.$loading.hide();
    },
    // 连通房和普通房间加购物车类似，只是需要连续加两间，并且两者的connect id必须相同
    async onConnectShoppingCartAdd(staterooms) {

      // 选房助手 10秒弹出 取消
      this.tenSecondDoFn = true

      if (
        staterooms.length < 2 ||
        staterooms[0].connectId != staterooms[1].connectId
      ) {
        return;
      }
      if (!this.userToken || this.userToken.length == 0) {
        let self = this;
        this.$confirm.show("您尚未登录， 请登录之后， 再添加舱房", {
          confirmCallBack: () => {
            self.$router.push({
              name: "Login",
              query: {
                returnUrl: location.href,
              },
            });
          },
        });
        return;
      }
      let requestData = {
        viewModel: staterooms[0],
      };
      try {
        if (window.gio && requestData.viewModel.isNrp) {
          gioTracking("track", "NRP_BF01");
        }
        gioTracking("track", "AddRoom", {
          GuestNumber: requestData.viewModel.guestNumber,
					RoomType: 'Connecting',
          RoomClass: requestData.viewModel.stateroomClass,
          RoomCategory: requestData.viewModel.stateroomCategoryCode,
          shipCode:this.shipCode,
          sailDate:this.sailDate
        });
      } catch (e) {
        console.error(e);
      }
      this.$loading.show();
      const result1 = await api.booking.addShoppingCart(requestData);
      if (!result1.success) {
        this.$alert.show(result1.errMsg);
        this.$loading.hide();
        return;
      }

      let requestData2 = {
        viewModel: staterooms[1],
      };
      try {
        if (window.gio && requestData2.viewModel.isNrp) {
          gioTracking("track", "NRP_BF01");
        }
        gioTracking("track", "AddRoom", {
          GuestNumber: requestData2.viewModel.guestNumber,
					RoomType: 'Connecting',
          RoomClass: requestData2.viewModel.stateroomClass,
          RoomCategory: requestData2.viewModel.stateroomCategoryCode,
          shipCode:this.shipCode,
          sailDate:this.sailDate
        });
      } catch (e) {
        console.error(e);
      }
      const reuslt2 = await api.booking.addShoppingCart(requestData2);
      if (!reuslt2.success) {
        this.$alert.show(reuslt2.errMsg);
      }
      this.$loading.hide();

      this.getShoppingCart();
    },
    // 获取港口名称
    getRouteName(routeEvent) {
      if (routeEvent.activity == "EMBARK" || routeEvent.activity == "DEBARK") {
        return routeEvent.harborCNName
      }
      return routeEvent.name;
    },
    // 抵港/出发港口时间
    getRouteTime(routeEvent) {
      let title = "";
      let arrivalTime = routeEvent.arrivalTime;
      if (arrivalTime && arrivalTime.length > 0) {
        if (arrivalTime.length > 5) {
          arrivalTime = arrivalTime.substring(0, 5);
        }
        title += "抵港 " + arrivalTime;
      }

      let departureTime = routeEvent.departureTime;
      if (departureTime && departureTime.length > 0) {
        if (departureTime.length > 5) {
          departureTime = departureTime.substring(0, 5);
        }
        title += "  起航 " + departureTime;
      }
      return title;
    },
    // 港口地址
    getRouteAddress(routeEvent) {
      if (routeEvent.portAddress) {
        return routeEvent.portAddress.replace("地址：", "");
      }
      return "";
    },
    showStateroomDetailPopup(stateroomData) {
      // pageScroll(false);
      this.selectStateroom = stateroomData;
      console.log(stateroomData)
      this.isShowStateroomDetailPopup = true;
      this.showPopup();
    },
    closeStateroomDetailPopup() {
      // pageScroll(true);
      this.selectStateroom = {
        stateroomImages: [],
        stateroomName: "",
        stateroomCategory: "",
        stateroomPriceType: "",
        stateroomPrice: 0,
        stateroomCapacity: "",
        stateroomArea: "",
        stateroomBalcony: "",
        stateroomFloor: "",
        isQiaohu: false,
        stateroomDescription: "",
        stateroomNrpTitle: "",
        stateroomNrpText: "",
        suiteMobileImageUrl: "",
        deviceGroupTags: []
      };
      this.isShowStateroomDetailPopup = false;
    },
    onConnectGuestSelected(connectGuestCount) {
      this.isConnectGuestRoom = true
      if (this.currentConnectGuestCount != connectGuestCount) {
        this.suiteTypeMenuInit();
        this.currentConnectGuestCount = connectGuestCount;
        if (this.currentConnectGuestCount.length > 0) {
          this.currentGuestNumber = 0;
          this.isShowConnect = false;
          this.getStateroomCategory();
          this.$refs.roomNav.scrollLeft = this.$refs.roomNavWrapper.offsetWidth;
					gioTracking('track', 'evt_GuestCount', {
						'GuestNumber': `C${connectGuestCount.replace(',', '')}`,
            'shipCode':this.shipCode,
            'sailDate':this.sailDate
					})
        }
      }
    },
    onConnectClose() {
      this.isShowConnect = false;
    },
    showStateroomSuitePopup(suiteImage) {
      if(this.cruiseDetail.shipCode !== 'SC') return;
      if (suiteImage && suiteImage.length > 0) {
        this.suiteImage = suiteImage;
        this.isShowSuitePopup = true;
      }
      this.showPopup();
    },
    closeStateroomSuitePopup() {
      this.isShowSuitePopup = false;
    },
    showSuiteTypeToSuiteDetails() {
      // this.showSuiteIntroducePopup();
      this.isShowSuiteTypeSelect = false;
      // console.log(this.$store.state.cruise.cruiseDetail,'this.$store.state.cruise.cruiseDetail');
      
      let data = this.$store.state.cruise.cruiseDetail.data
      if(data && data.suiteLinkMB){
        window.open(data.suiteLinkMB,'_blank')
      }
      
    },
    showQiaohuPopup() {
      this.isShowQiaohuPopup = true;
      this.showPopup();
    },
    closeQiaohuPopup() {
      this.isShowQiaohuPopup = false;
    },
    showStarrySkyPopup() {
      this.isShowStarrySkyPopup = true;
    },
    closeStarrySkyPopup() {
      this.isShowStarrySkyPopup = false;
    },
    showCustomThemePopup(val) {
      this.personalizedStateroomInfo = val;
      this.isShowCustomThemePopup = true;
    },
    closeCustomThemePopup() {
      this.isShowCustomThemePopup = false;
    },
    showConnectRoomPopup() {
      this.isShowConnectRoomPopup = true;
      this.showPopup();
    },
    closeConnectRoomPopup() {
      this.isShowConnectRoomPopup = false;
    },
    showCruiseTagPopup() {
      this.isShowCruiseTagPopup = true;
      this.showPopup();
    },
    showTicketContainsPopup() {
      pageScroll(false);
      this.isShowTicketContainsPopup = true;
      this.showPopup();
    },
    closeCruiseTagPopup() {
      this.isShowCruiseTagPopup = false;
    },
    closeTicketContainsPopup() {
      pageScroll(true);
      this.isShowTicketContainsPopup = false;
    },
    showSuiteIntroducePopup() {
      pageScroll(false);
      this.isShowSuiteIntroducePopup = true;
      this.showPopup();
    },
    closeSuiteIntroducePopup() {
      pageScroll(true);
      this.isShowSuiteIntroducePopup = false;
    },
    showCancelPolicyPopup() {
      this.isShowCancelPolicyPopup = true;
      this.showPopup();
    },
    closeCancelPolicyPopup() {
      this.isShowCancelPolicyPopup = false;
    },
    showCruisePriceInfo() {
      this.isShowCruisePriceInfoPopup = true;
      this.showPopup();
      gioTracking('track','evt_ButtonClicked', {'btnType':'priceStatement'})
    },
    closeCruisePriceInfo() {
      this.isShowCruisePriceInfoPopup = false;
    },
    showRouteInfoPopup() {
      this.isShowRouteInfoPopup = true;
      this.showPopup();
    },
    closeRouteInfoPopup() {
      this.isShowRouteInfoPopup = false;
    },
    showBookingPolicyPopup(policyTab) {
      this.currentPolicyTab = policyTab;
      this.isShowBookingPolicyPopup = true;
      this.showPopup();
    },
    closeBookingPolicyPopup() {
      this.currentPolicyTab = 0;
      this.isShowBookingPolicyPopup = false;
    },
    showBankPopup() {
      this.isShowBankPopup = true;
      this.showPopup();
    },
    closeBankPopup() {
      this.isShowBankPopup = false;
    },
    async showShorexPopup(cityName, seaDay) {
      this.$loading.show();
      const { success, data, errMsg } = await api.cruise.getShorexByCity({
        cityName,
        shipCode: this.shipCode,
        sailDate: this.sailDate,
        seaDay: seaDay,
      });
      this.$loading.hide();
      if (!success) {
        if (errMsg && errMsg.length > 0) {
          this.$alert.show(errMsg);
        }
      } else {
        this.shorexInfo = {
          freeShorex: data.freeShorex,
          payShorex: data.payShorex,
          payShorexOnly: this.cruiseDetail?.payShorexOnly || false
        };
        this.isShowShorexPopup = true;
        this.showPopup();
      }
    },
    closeShorexPopup() {
      this.isShowShorexPopup = false;
    },
    showCruiseCoupon() {
      this.isShowCruiseCoupon = true;
    },
    closeCruiseCoupon() {
      this.isShowCruiseCoupon = false;
    },
    setCouponRecieved(id) {
      let coupon = this.coupons.find((r) => r.id == id);
      if (coupon) {
        coupon.couponState = 2;
      }
    },
    showCouponRule(couponRule) {
      this.couponRule = couponRule;
      this.isShowCouponRule = true;
      this.showPopup();
    },
    closeCouponRule() {
      this.couponRule = "";
      this.isShowCouponRule = false;
    },
    showPopup() {
      history.pushState({ page: "detail" }, null);
    },
    onNavChange(index) {
      this.navIndex = index;
      let scrollTop = 0;
      switch (index) {
        case 0:
          scrollTop = this.$refs.detailRoom.offsetTop - 90;
          break;
        case 1:
          scrollTop = this.$refs.routeContent.offsetTop - 90;
          break;
        case 2:
          scrollTop = this.$refs.bookingPolicyContent.offsetTop - 90;
          break;
        case 3:
          scrollTop = this.$refs.reviewContent.offsetTop - 90;
          break;
      }
      window.scroll({ top: scrollTop, behavior: "smooth" });
    },
    pageScrollHandler(scrollTop) {
      this.startTimer();
      // 显示滚动到顶的按钮
      if (this.$refs.toScrollTop) {
        if (scrollTop > 300) {
          this.$refs.toScrollTop.style.display = "block";
        } else {
          this.$refs.toScrollTop.style.display = "none";
        }
      }

      // 导航吸顶
      if (this.$refs.detailRoom) {
        const navTop = this.$refs.detailRoom.offsetTop - 50;
        if (navTop < scrollTop && navTop >= 0) {
          this.isNavFixed = true;
        } else {
          this.isNavFixed = false;
        }
        if (
          this.$refs.reviewContent &&
          scrollTop > this.$refs.reviewContent.offsetTop - 100
        ) {
          this.navIndex = 3;
        } else if (
          this.$refs.bookingPolicyContent &&
          scrollTop > this.$refs.bookingPolicyContent.offsetTop - 100
        ) {
          this.navIndex = 2;
        } else if (
          this.$refs.routeContent &&
          scrollTop > this.$refs.routeContent.offsetTop - 100
        ) {
          this.navIndex = 1;
        } else {
          this.navIndex = 0;
        }
      }
    },
    scrollToTop() {
      window.scroll({ top: 0, behavior: "smooth" });
      gioTracking('track','evt_ButtonClicked', {'btnType':'toTop'})
    },
    showSpecialBookingPopup() {
      this.isShowSpecialBookingRuleImagePopup = true;
    },
    closeSpecialBookingPopup() {
      this.isShowSpecialBookingRuleImagePopup = false;
    },
    suiteTypeMenuInit() {
      this.disableSuiteTypeList = [];
      this.currentSuiteType = {
        id: 'ALL',
        title: '全部',
        type: null,
        isSelected: true
      };
    },
    async checkTikTokCampaignCode(cruiseId) {
      let tikTokCode = sessionStorage.getItem('tikTokCode');
      if (!isEmpty(tikTokCode) && !isEmpty(cruiseId)) {
        let { success } = await api.tikTok.checkCanApplyByCampaignCode({
          tikTokCampaignCode: tikTokCode,
          cruiseId: cruiseId
        });
        if(success) {
          this.allowUseTikTokCode = true;
          sessionStorage.setItem('isUseTikTokCode', 'true');
        } else {
          this.allowUseTikTokCode = false;
          sessionStorage.setItem('isUseTikTokCode', 'false');
        }
      }
    },
    async getShipVrMiniSite() {
      let { success, data} = await api.cruise.getShipVrMiniSiteApi({
        shipCode: this.shipCode,
        pageKey:'CruiseDetail',
        source:'MB'
      });
      if(success){
        this.vrUrl = data.url;
      }
    },
    closeOutOfStockPopup(){
      this.isShowOutOfStockPopup = false
    },
    changeOutOfStockRoom(i,idx){
      this.outOfStockRoom[idx].isActive = !this.outOfStockRoom[idx].isActive
      this.outOfStockRoom.forEach(i=>{
        if(i.isActive){
          this.isHaveRegistered = !!i.isRecorded
        }
      })
      if(this.outOfStockRoom.every(i=>!i.isActive)){
        this.isHaveRegistered = false
      }
    },
    // 获取登记缺货信息
    async getOutOfStockInfo(stateroomType) {
      if(!this.cruiseDetail.outOfStockEnable)return
      if (!this.userToken || this.userToken.length == 0) {
        let self = this;
        this.$confirm.show("您尚未登录， 请登录之后， 再进行缺货登记", {
          confirmCallBack() {
            self.$router.push({
              name: "Login",
              query: {
                returnUrl: location.href,
              },
            });
          },
        });
        return;
      }
      // 如果是联通房，相加乘客人数
      if(this.currentConnectGuestCount.length>0){
        this.guestNumberCount = this.currentConnectGuestCount
        this.cabinRoomType = 'CONNECT_ROOM'
      }else{
        this.guestNumberCount = this.currentGuestNumber
        this.cabinRoomType = 'STANDARD'
      }
      // 显示缺货登记弹窗
      this.isShowOutOfStockPopup = true
      let params = {
        ShipCode: this.shipCode,
        SailDateStr: this.sailDate,
        GuestCount: this.cabinRoomType==='STANDARD'?this.guestNumberCount:'',
        StateroomClassCode: stateroomType,
        Type:this.cabinRoomType,
        ConnectRoomGuest:this.cabinRoomType==='CONNECT_ROOM'?this.guestNumberCount:'',
      }
      this.roomName = this.setRoomName(stateroomType, this.guestNumberCount)
      this.$loading.show();
      let {success, data , errMsg} = await api.cruise.getOutOfStockInfo(params)
      this.$loading.hide();
      if(success){
        data.stateroomSubClasses && data.stateroomSubClasses.forEach(item => {
          item.isActive = false
        })
        if(data.stateroomSubClasses && data.stateroomSubClasses.length ===1){
          this.hideSelectRoom = true
          if(data.stateroomSubClasses[0].isRecorded){
            this.isHaveRegistered = true
          }else{
            data.stateroomSubClasses[0].isActive = true
            this.isHaveRegistered = false
          }
        }else{
          this.hideSelectRoom = false
          this.isHaveRegistered = false
        }
        this.stateroomType = stateroomType
        this.outOfStockRoom = data.stateroomSubClasses
        this.outOfStockCruiseList = data.cruiseSearchItems
      }else{
        this.$alert.show(errMsg)
      }
    },
    // 获取舱房名称
    setRoomName(stateroomType, num) {
      const guestNumbers = ['', '单人', '双人', '三人', '四人', '五人'];
      const roomTypes = {
        INTERIOR: '内舱房',
        OUTSIDE: '海景房',
        BALCONY:'阳台房',
        DELUXE:'套房'
      };
      if(this.guestNumberCount == '2,2'){
        return '连通' + (roomTypes[stateroomType] || '') + ' (双人房+双人房)';
      }
      if(this.guestNumberCount == '2,3'){
        return '连通' + (roomTypes[stateroomType] || '') + ' (双人房+三人房)';
      }
      return (guestNumbers[num] || '') + (roomTypes[stateroomType] || '');
    },
    //   提交缺货登记
    async submitOutOfStock() {
      if (this.isShowNullRoomTips) return;
      let ids = []
      if (this.outOfStockRoom && this.outOfStockRoom.length > 0) {
        this.outOfStockRoom.forEach(item => {
          if (item.isActive) {
            ids.push(item.stateroomSubClassId)
          }
        })
      }
      if (ids.length <= 0) {
        this.isShowNullRoomTips = true
        setTimeout(() => {
          this.isShowNullRoomTips = false
        }, 1500)
        return
      }
      let params = {
        ShipCode: this.shipCode,
        SailDateStr: this.sailDate,
        GuestCount: this.cabinRoomType==='STANDARD'?this.guestNumberCount:'',
        Source: "mobile",
        StateroomSubClassRecordIds: ids,
        Type:this.cabinRoomType,
        ConnectRoomGuest:this.cabinRoomType==='CONNECT_ROOM'?this.guestNumberCount:''
      }
      this.$loading.show();
      let {success,errMsg} = await api.cruise.submitOutOfStock(params)
      this.$loading.hide();
      if (success) {
        this.$alert.show('提交成功')
        // 提交成功后，如果偏好房间就一个选项，隐藏偏好选择
        if(this.outOfStockRoom.length<=1){
          this.hideSelectRoom = true
        }
        this.isHaveRegistered = true
      }else{
        this.$alert.show(errMsg)
      }
    },
    getCruiseOutOfStock() {
      try {
        const stateroomTypes = ['INTERIOR', 'OUTSIDE', 'BALCONY', 'DELUXE'];
        const allSoldOut = stateroomTypes.every(type => {
          const isSoldOut = this.isStateroomSoldout(type);
          return isSoldOut === true; // 确保返回值是布尔类型
        });
        return allSoldOut;
      } catch (error) {
        console.error('Error in getCruiseOutOfStock:', error);
        return false; // 在发生异常时返回 false，确保方法总是有明确的返回值
      }
    },
    getCruiseCampaignInfo() {
      const cruiseCampaign = this.$store.state.cruise.cruiseDetail.data.cruiseCampaign || {};
      let nowTime = new Date();
      let startDate = new Date(cruiseCampaign.startDateStr);
      let endDate = new Date(cruiseCampaign.endDateStr);
      let seconds = cruiseCampaign.remainingSeconds;
      if (nowTime > startDate && nowTime < endDate) {
        cruiseCampaign.isShowCruiseCampaign = true
        if (cruiseCampaign.type === 1) {
          if (this.countDownTimer) {
            clearInterval(this.countDownTimer);
          }
          this.countDownTimer = setInterval(() => {
            if (seconds - 1 <= 0) {
              cruiseCampaign.isShowCruiseCampaign = false
              this.cruiseCampaign = { ...cruiseCampaign };
              clearInterval(this.countDownTimer);
            } else {
              seconds -= 1;
              cruiseCampaign.time = updateCountdown(seconds);
              this.cruiseCampaign = { ...cruiseCampaign };
            }
          }, 1000);
        }
      }
      this.cruiseCampaign = { ...cruiseCampaign };
    },
    async onGetCouponClick(coupon) {
      if (coupon.couponState == 2) {
        return
      }
      const userToken = this.$store.state.user.userToken
      if (!userToken || userToken.length == 0) {
        this.$confirm.show('您尚未登录， 请登录之后， 再领取优惠券', {
          confirmCallBack: () => {
            this.$router.push({ name: 'Login', query:{
                returnUrl: location.href
              }})
          }
        })
        return
      }
      this.$loading.show()
      const { success, errMsg } = await api.booking.giveUserCoupon({
        id: coupon.id,
        source: 'mobile'
      })
      this.$loading.hide()
      if (!success) {
        this.$alert.show(errMsg)
        return
      }
      this.setCouponRecieved(coupon.id)
    },
    getStateroomKey(stateroomType, stateroom, index) {
      return `stateroom_${stateroom.currentGuestNumber}_${stateroomType}_${stateroom.stateroomCategoryCode}_${index}`
    },
    getConnectStateroomKey(stateroom, index) {
      const { connectStateroomFirsts, connectStateroomSeconds } = stateroom || {}
      if(!connectStateroomFirsts || !connectStateroomSeconds){
        return `connect_${stateroom.connectId}_${index}`
      }
      let currentGuestNumber = `${connectStateroomFirsts?.currentGuestNumber}-${connectStateroomSeconds?.currentGuestNumber}`
      let stateroomCategoryCode = `${connectStateroomFirsts?.stateroomCategoryCode||'unknown'}-${connectStateroomSeconds?.stateroomCategoryCode||'unknown'}`
      return `connect_${stateroom.connectId}_${currentGuestNumber}_${stateroom.stateroomType}_${stateroomCategoryCode}_${index}`
    },
    async getBannerIncludesBirthdayList() {
      const shipCode = this.$router.currentRoute.query.shipCode;
      const sailDate = this.$router.currentRoute.query.sailDate;
      // 防重：相同船期已成功加载过则跳过（created + activated 双调用场景避免重复请求）
      const key = `${shipCode}_${sailDate}`;
      if (this.bannerIncludesBirthdayLoadedKey === key) return;
      const { success,data } = await api.cruise.getCruisePromoBanner({
        shipCode,
        sailDate
      });
      if(success) {
        // 只有请求成功才记录key，失败时下次进入可重试
        this.bannerIncludesBirthdayLoadedKey = key;
        this.bannerIncludesBirthdayList = data?.filter(r => r.image) ?? [];
      }
    },
    handleBannerToJump(banner) {
      if(banner.showType === "birthdayGift") {
        this.showSpecialBookingPopup();
      } else {
        if(banner.link) {
          window.location.href = banner.link;
        }
      }
    }
  },
  computed: {
    cruiseDetail() {
      this.checkTikTokCampaignCode(this.$store.state.cruise.cruiseDetail.data.cruiseId);
      return this.$store.state.cruise.cruiseDetail.data;
    },

    isShowFolded() {
      let arr = this.getStateroomList(this.currentStateroomType)
      let index = arr.findIndex(item => item.isFolded == true)
      return index > 0
    },
    isShowItem(){
      return (item)=>{
        if(item.isFolded == true && this.clickItem == false){
          return false
        }else{
          return true
        }
      }
    },

    isShowFoldedCon() {
      let arr = this.getConnectStateroom(this.currentStateroomType).filter(item => {
        if(item.stateroomType === this.currentStateroomType){
          return true
        }
      })
      let index = arr.findIndex(item => item.isFolded == true)
      return index > 0
    },
    isShowItemCon(){
      return (item)=>{
        if(item.isFolded == true && this.clickItemCon == false){
          return false
        }else{
          return true
        }
      }
    },

    shipCode() {
      return this.$store.state.cruise.cruiseDetail.shipCode;
    },
    sailDate() {
      return this.$store.state.cruise.cruiseDetail.sailDate;
    },
    stateroomTypes() {
      return ["INTERIOR", "OUTSIDE", "BALCONY", "DELUXE"];
    },
    cruiseDetailSuccess() {
      return this.$store.state.cruise.cruiseDetail.success;
    },
    needShowConnectRoom() {
      return (
        this.cruiseDetail.shipCode == "SC" || this.cruiseDetail.shipCode == "QN" || this.cruiseDetail.shipCode == "WN"
      );
    },
    cruiseCoupons() {
      return this.$store.state.cruise.cruiseDetail.data.couponInfos || [];
    },
    isShowNrp() {
      if (!this.cruiseDetail.price) {
        return false;
      }
      const nrpPrice = this.cruiseDetail.price.nrpAmout;
      const rpPrice = this.cruiseDetail.price.netAmout;
      if (nrpPrice > 0 && nrpPrice <= rpPrice) {
        return true;
      }
      return false;
    },
    userToken() {
      return this.$store.state.user.userToken;
    },
    qiaohuGroup() {
      if (
        this.cruiseDetail.cruiseGroups &&
        this.cruiseDetail.cruiseGroups.length > 0
      ) {
        const cruiseGroups = this.cruiseDetail.cruiseGroups.filter(
          (group) => group.groupType == "QIAOHU" && group.isPublished
        );
        if (cruiseGroups && cruiseGroups.length > 0) {
          return cruiseGroups[0];
        }
      }
      return {};
    },
    isConnectRoomMode() {
      return this.currentConnectGuestCount.length > 0;
    },
    departureCode() {
      let code = "";
      if (
        this.cruiseDetail &&
        this.cruiseDetail.ports &&
        this.cruiseDetail.ports.length > 0
      ) {
        code = this.cruiseDetail.ports[0].code;
      }
      return code;
    },
    agencyId() {
      if (wechatHelper.isWeixinBrowser()) {
        return "347880";
      }
      return "336801";
    },
    tags() {
      if (
        this.cruiseDetail &&
        this.cruiseDetail.tags &&
        this.cruiseDetail.tags.length > 0
      ) {
        return this.cruiseDetail.tags;
      }
      return [];
    },
    specialBooking() {
      if (
        this.cruiseDetail &&
        this.cruiseDetail.specialBookingViews &&
        this.cruiseDetail.specialBookingViews.length > 0
      ) {
        return this.cruiseDetail.specialBookingViews[0];
      }
      return {};
    },
    specialBookingName() {
      if (this.specialBooking) {
        if (
          this.specialBooking.specialBookingType == SpecialBookingType.Birthday
        ) {
          return "皇家生日礼遇";
        } else if (this.specialBooking.specialBookingType == 2) {
          return "皇家周年礼遇";
        }
      }
      return "";
    },
    specialBookingRuleImage() {
      return this.specialBooking.mobileRuleDescriptionImage || "";
    },
    specialBookingMobileBanner() {
      return this.specialBooking.mobileBanner || "";
    },
    isShowSpecialBooking() {
      return this.cruiseDetail.specialBookingViews.length > 0;
    },
    cruiseCategories() {
      const homePage = this.$store.state.page.homePage;
      if (
          homePage &&
          homePage.recommendCruiseArea &&
          homePage.recommendCruiseArea.promoCruiseCategories
      ) {
        return homePage.recommendCruiseArea.promoCruiseCategories;
      }
      return [];
    },
    promoCruiseItems() {
      const homePage = this.$store.state.page.homePage;
      if (
          homePage &&
          homePage.recommendCruiseArea &&
          homePage.recommendCruiseArea.cruisePromoItems
      ) {
        return homePage.recommendCruiseArea.cruisePromoItems;
      }
      return [];
    }
  },
  watch: {
    cruiseDetailSuccess(newOne) {
      if (!newOne) {
        this.$router.go(-1);
      }
    },
    cruiseDetail(newOne) {
      
      if (newOne.price && newOne.price.nrpGuestNumber > 0) {
        this.currentGuestNumber = newOne.price.nrpGuestNumber;
        // this.currentStateroomType = newOne.price.nrpBestPriceStateroom
      } else if (newOne.price && newOne.price.guestNumber > 0) {
        this.currentGuestNumber = newOne.price.guestNumber;
        // this.currentStateroomType = newOne.price.bestPriceStateroom
      }
      this.currentConnectGuestCount = "";
      this.isInWishList = newOne.isCruiseWish;
      this.collections = newOne.collections;

      this.getStateroomCategory();
      this.getCruiseReviews();
      window.scrollTo(0, 0);

      if (wechatHelper.isWeixinBrowser()) {
        let content = `航线详情：${newOne.routeName} ${
          newOne.sailDateBegin
        } - ${newOne.sailDateEnd} ${newOne.sailDays}天${newOne.sailDays - 1}晚`;
        setTimeout(() => {
          wechatHelper.wechatShareConfig("", content, location.href, "");
        }, 3000);
      }

      if (newOne.ports && newOne.ports.length > 0) {
          if (
            isHkSpecialCruise(
              newOne.shipCode,
              newOne.sailDate,
              newOne.ports[0].code
            )
          ) {
            const hkWarning = '<div style="text-align: left;">'+
              '<p>2021年香港复航航次乘客要求</p>' +
              '<p>根据政府相关指引以及卫生防控需要，乘客必须同时符合以下条件方可登船：</p>' +
              '<p>1. 香港居民</p>' +
              '<p>2. 已在登船日14天前接种2剂新冠疫苗，持有医疗证明不适合接种疫苗或12周岁以下人士除外</p>' +
              '<p>3. 登船日前48小以内进行了核酸检测，且报告结果为阴性。</p>' +
              '<p>4. 登船日前14天以内未到访或途经特区政府发出禁止来港极高风险地区。</p>'+
              '</div>'
            this.$alert.show(hkWarning);
          }
        }
        
        if(newOne){
          // 清空10显示 选房助手
          this.tenSecondDoFn = false
          this.startTimer();
        }
    },
    cruiseCoupons(newOne) {
      this.coupons = newOne;
    },
    '$store.state.cruise.cruiseDetail.data.cruiseCampaign': {
      handler() {
        this.getCruiseCampaignInfo();
      },
      deep: true
    }
  },
};
</script>

<style lang="less" scoped>
* {
  
}
.packageDetail {
  margin-top: 50px;
  overflow-y: auto;
  padding-bottom: 95px;
  background: #f6f7f8;
  .packageDetail-tip {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    background-color: #e7292e;
    img {
      display: block;
      width: 12px;
      margin-right: 6px;
      margin-top: -3px;
    }
    .packageDetail-tip-txt {
      font-size: 12px;
      line-height: 25px;
      color: #fff;
    }
  }
  .packageDetail-banner {
    width: 100%;
    position: relative;
    .swiper-slide img {
      width: 100%;
    }
    .bannerSwiper .swiperOrder {
      position: absolute;
      bottom: 9px;
      left: 18px;
      width: 38px;
      text-align: center;
      height: 16px;
      line-height: 15px;
      background: rgba(0, 0, 0, 0.4);
      border-radius: 8px;
      
      font-size: 12px;
      color: #ffffff;
      letter-spacing: 1px;
      z-index: 2;
      display: block;
    }

    .packageDetail-like {
      position: absolute;
      right: 20px;
      bottom: -12px;
      z-index: 22;
      width: 40px;
      height: 40px;
      padding-top: 6px;
      text-align: center;
      border-radius: 50%;
      background: #ffffff;
      -webkit-box-shadow: 0 4px 8px 0 rgba(214, 215, 216, 0.5);
      box-shadow: 0 4px 8px 0 rgba(214, 215, 216, 0.5);
      > div img {
        width: 20px;
        margin: 0 auto;
        display: block;
      }

      > p {
        margin: 2px 0 0;
        font-size: 9px;
        line-height: 12px;
        color: #ff5055;
        text-align: center;
      }
    }
  }

  .packageDetail-cruiseInfo {
    background-color: #fff;
    padding: 17px 20px 12px 20px;
    position: relative;
    z-index: 21;

    .packageDetail-cruiseInfo-title {
      
      font-size: 15px;
      color: #333333;
      letter-spacing: 0;
      font-weight: bold;
    }
    .packageDetail-cruiseInfo-sailDays {
      
      font-size: 12px;
      color: #666666;
      letter-spacing: 1.71px;
      margin-top: 4px;
    }
    .packageDetail-cruiseInfo-sailDate {
      
      font-size: 12px;
      color: #666666;
      margin-top: 4px;
      span {
        display: inline-block;
        vertical-align: middle;
        margin-right: 4px;
      }
      .packageDetail-cruiseInfo-otherDate img {
        width: 18.5px;
        height: 20px;
        vertical-align: middle;
      }
      .packageDetail-cruiseInfo-otherDate span {
        color: #4a90e2;
        margin-left: 2px;
      }
    }
    .packageDetail-cruiseInfo-price {
      
      display: -webkit-box;
      display: -webkit-flex;
      display: -moz-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: baseline;
      -webkit-align-items: baseline;
      -moz-box-align: baseline;
      -ms-flex-align: baseline;
      align-items: baseline;
      font-size: 12px;
      line-height: 16px;
      color: #666;

      .packageDetail-cruiseInfo-price-txt {
        margin-right: 3px;
        font-size: 18px;
        line-height: 21px;
        color: #ff0000;
        font-weight: bold;
        span {
          font-size: 12px;
          line-height: 16px;
          margin-right: 4px;
        }
      }
    }
    .packageDetail-cruiseInfo-tags {
      overflow: hidden;
      margin-top: 6px;
      .tagDetail {
        float: left;
        margin-right: 9px;
        margin-bottom: 6px;
        padding: 0 6px;
        background: rgba(37, 96, 212, 0.05);
        border-radius: 5px;
        
        font-size: 11px;
        line-height: 18px;
        color: #4a90e2;
        letter-spacing: 1.43px;
        text-align: center;
      }

      .tagLink {
        background: #febc10;
        a {
          color: #fff;
        }
      }
      .highShow {
        background: #febc10;
        color: #fff;
      }
      .promptHot,
      .tags-rule {
        float: left;
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        margin-right: 12px;
        margin-bottom: 6px;
        font-size: 11px;
        line-height: 18px;
        color: #4a90e2;
        img {
          display: block;
          margin-left: 1px;
          width: 12px;
        }
      }
      .promptHot {
        color: #ff2b2b !important;
        img {
          display: block;
          margin-right: 2px;
          width: 13px;
        }
      }
    }
    .receive-coupon{
      display: flex;
      align-items: center;
      gap: 6px;
      overflow-x: auto;
      overflow-y: hidden;
      width: calc(100% + 20px);
      padding-bottom: 1px;
      //隐藏滚动条
      & ::-webkit-scrollbar {
        display: none;
      }
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none;
      .coupon-item{
        width: 166px;
        background: url("https://resource.rcclchina.com.cn/common/coupon/couponBg.png") no-repeat;
        background-size: 100% 100%;
        font-weight: 500;
        font-size: 12px;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        cursor: pointer;
        &:last-child {
          margin-right: 20px;
        }
        & .item-left{
          width: 128px;
          height: 25px;
          line-height: 25px;
          padding: 0 4px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: center;
        }
        & .item-right{
          width: 38px;
          height: 25px;
          line-height: 25px;
          text-align: center;
          white-space: nowrap;
        }
      }
      .coupon-claimed{
        color: #fb6b15;
        background: url("https://resource.rcclchina.com.cn/common/coupon/couponBgDisabled.png") no-repeat;
        background-size: 100% 100%;
      }
    }
  }

  .packageDetail-coupon {
    margin-top: 10px;
    padding: 15px 20px;
    background-color: #fff;
    overflow: hidden;
    .packageDetail-coupon-l {
      float: left;
      img {
        width: 22px;
        font-size: 0;
        vertical-align: middle;
      }
      span {
        display: inline-block;
        vertical-align: middle;
        
        font-size: 13px;
        color: #4a90e2;
        letter-spacing: 1px;
        text-align: center;
        margin-left: 4px;
      }
    }
    .packageDetail-coupon-r {
      float: right;
      margin-top: 8px;
      > img {
        width: 8px;
      }
    }
  }

  .packageDetail-container {
    margin-top: 10px;
    .packageDetail-nav {
      background-color: #fff;
      overflow: hidden;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
      -moz-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
      padding: 0 20px;
      position: relative;
      z-index: 2;
      display: flex;
      > div {
        float: left;
        
        font-size: 14px;
        color: #666666;
        letter-spacing: 2px;
        width: 25%;
        text-align: center;
        flex: 1;
        > span {
          display: inline-block;
          height: 49px;
          line-height: 49px;
        }
      }
      > div.active > span {
        
        color: #4a90e2;
        border-bottom: 2px solid #4a90e2;
      }
    }

    .packageDetail-nav.outDetailNav {
      position: fixed;
      top: 50px;
      width: 100%;
      z-index: 2287;
    }

    .packageDetail-room {
      padding: 0 10px 10px;
      background-color: #fff;
      margin-top: 10px;
      .packageDetail-roomTitle {
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        height: 46px;
        .packageDetail-roomTitle-l {
          -webkit-box-flex: 1;
          -webkit-flex: 1;
          -moz-box-flex: 1;
          -ms-flex: 1;
          flex: 1;
          display: -webkit-box;
          display: -webkit-flex;
          display: -moz-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: center;
          -webkit-align-items: center;
          -moz-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          .packageDetail-roomTitle-l-txt1 {
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            margin-right: 10px;
            font-size: 14px;
            line-height: 20px;
            color: #333;
            font-weight: bold;
            img {
              display: block;
              width: 22px;
              margin-right: 5px;
            }
          }

          .packageDetail-roomTitle-l-txt2 {
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            font-size: 11px;
            line-height: 16px;
            color: #4a90e2;
            img {
              display: block;
              width: 12px;
              margin-left: 1px;
            }
          }
        }
      }

      .packageDetail-roomNav {
        overflow: hidden;
        overflow-x: auto;
        position: relative;
        width: 100%;
        left: 0;
        border-top: 1px solid #e1e1e1;
        overflow-x: scroll;
        .packageDetail-roomNav-wrapper {
          width: 100vw;
          overflow-y: hidden;
          white-space: nowrap;
          overflow-x: scroll;
          padding-right: 10px;
          padding-bottom: 7px;
          display: flex;
          align-items: center;
          .c_room {
            position: relative;
            float: left;
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: center;
            -webkit-justify-content: center;
            -moz-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -webkit-flex-direction: column;
            -moz-box-orient: vertical;
            -moz-box-direction: normal;
            -ms-flex-direction: column;
            flex-direction: column;
            width: 29%;
            /* height: 38px; */
            height: 47px;
            text-align: center;
            background: url(https://resource.rcclchina.com.cn/mobile2/cruiseDetail/connect/mb_nav_bg.png)
              no-repeat right center;
            background-size: 1px 30%;
            p:first-of-type {
              
              font-size: 12px;
              color: #666666;
              letter-spacing: 1px;
              margin: 0;
            }
            p:last-child {
              //display: none;
              margin: 0;
              
              font-size: 10px;
              line-height: 13px;
              color: #666666;
              letter-spacing: 0.71px;
            }
            img {
              position: absolute;
              left: 0px;
              top: -1px;
              width: 24px;
            }
            > div > .QIAOHU_Stateroom_Number_CSS {
              
              font-size: 12px;
              line-height: 12px;
              letter-spacing: 1px;
              position: absolute;
              left: 16px;
              top: 9px;
              color: #666666;
            }

            .QIAOHU_Stateroom_Title_CSS {
              font-size: 10px;
              color: #febc10;
              position: absolute;
              left: 10px;
              top: 16px;
              line-height: 1;
            }
          }
          p:last-child{
            display: none;
          }
          .active .c_room_outOfStock p:last-child{
            display: block;
          }
          .c_last_div .c_wrap {
            display: none;
          }
          .c_last_div .c_wrap {
            display: none;
          }
          .c_room.c_connect_room_tab {
            margin-right: 0;
            background: none;
            width: 120px !important;
            white-space: nowrap;

          }
          .active .c_room_outOfStock .optOfSellOut{
            display: inline-block !important;
          }
          .optOfSellOut{
            display: none;
          }
        }

        div.c_room.active > div {
          background-color: #febc10;
          width: 92%;
          height: 43px;
          border-radius: 3px;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
        }
        div.c_room.active > div > .QIAOHU_Stateroom_Number_CSS {
          top: 7px;
        }
        div.c_room.active .QIAOHU_Stateroom_Title_CSS {
          top: 14px;
          color: #333;
        }
        div.c_room.active p:first-of-type {
          color: #333;
          font-weight: 500;
        }

        .c_last_div.active .c_wrap > span {
          width: 0;
          height: 0;
          border-width: 4px;
          border-style: solid;
          border-color: #fff transparent transparent transparent;
          position: relative;
          top: 4px;
        }

        .c_last_div.active .c_wrap {
          display: block;
          width: 100%;
          height: 2px;
          background-color: #ffdb59;
          position: absolute;
          left: 0;
          bottom: 0;
          padding-top: 4px;
        }

        div.c_room.active > div.c_line.hasSelected {
          position: relative;
          line-height: 14px;
          width: 110px;
          left: 10px;
        }

        .hasSelected p:first-of-type {
          padding-top: 8px;
        }

        span.c_room_title {
          font-size: 12px;
        }
        span.c_room_subtitle {
          font-size: 10px;
          font-weight: normal;
        }
      }
      .css-has-connect-room .c_room {
        width: 75px !important;
      }
      .packageDetail-roomCat {
        background-color: #fff;
        border-bottom: 1px solid #e1e1e1;
        position: relative;
        top: -7px;
        .packageDetail-roomCatCon {
          position: relative;
          background-color: #fff;
          padding: 0px 10px;
          top: 8px;
          .roomCat-item {
            position: relative;
            float: left;
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: center;
            -webkit-justify-content: center;
            -moz-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -webkit-flex-direction: column;
            -moz-box-orient: vertical;
            -moz-box-direction: normal;
            -ms-flex-direction: column;
            flex-direction: column;
            text-align: center;
            width: 24%;
            height: 38px;
            margin-right: 1%;
            background-color: transparent;
            /* border: 1px solid #FBC500; */
            border-radius: 4px;
            -webkit-border-radius: 4px;
            -moz-border-radius: 4px;
            background-color: #f8f8f8;
            border: 1px solid #f8f8f8;
            > div {
              
              font-size: 12px;
              line-height: 20px;
              color: #666666;
              letter-spacing: 1px;
            }
            .js_sailOut {
              display: none;
              font-size: 10px;
              line-height: 13px;
              letter-spacing: 0;
              i{
                font-style: normal;
              }
            }
          }
          .roomCat-item.active {
            background-color: #febc10;
            border: 1px solid #febc10 !important;
            > div {
              color: #333 !important;
              font-weight: 500;
            }
          }
          .roomCat-item.active:after {
            position: absolute;
            left: 35px;
            bottom: -5px;
            content: "";
            width: 6px;
            height: 6px;
            border: 1px solid #febc10;
            transform: rotate(45deg);
            background: #febc10;
            border-left-color: #febc10;
            border-top-color: #febc10;
          }
          .roomCat-item.noactive > div.js_sailOut {
            color: #666666;
            display: block;
          }
          .roomCat-item.roomCat-item-type3 .roomCat-item-Txt {
            display: block;
            font-weight: normal;
            position: relative;
            z-index: 1;
          }
        }
      }
      .room-noContent {
        
        font-size: 14px;
        color: #999999;
        letter-spacing: 1px;
        margin-top: 30px;
        padding-bottom: 30px;
        text-align: center;
        display: none;
      }
      .packageDetail-roomCon {
        clear: both;
        margin-top: 52px;
        .room_cabin_content {
          display: none;
          .room_cabin_list {
          }
          .c_cabin_list {
            position: relative;
            overflow: hidden;
            border-radius: 5px;
            box-shadow: 0px 0px 7px 3px rgba(46, 65, 80, 0.1);
          }
        }
      }
    }

    .packageDetail-route {
      .packageDetail-routeCon {
        background-color: #fff;
        padding: 10px 20px;
        margin-top: 10px;
        .packageDetail-routeTop {
          padding-bottom: 6px;
          border-bottom: 1px solid #cccccc;
          .packageDetail-routeTitle {
            img {
              width: 15px;
              vertical-align: middle;
            }
            span {
              
              font-size: 14px;
              color: #333333;
              letter-spacing: 0;
              font-weight: bold;
              display: inline-block;
              vertical-align: middle;
              margin-left: 4px;
              &.route-tips {
                font-weight: normal;
                font-size: 10px;
                padding-left: 22px;
                margin: 5px 0px;
              }
            }
          }
          .packageDetail-routeTitle-tips {
            
            font-size: 10px;
            color: #999999;
            padding-left: 22px;
          }
        }
        .packageDetail-routePlace {
          margin-top: 6px;

          .packageDetail-routeItem {
            .packageDetail-routePlane-order,
            .packageDetail-routeFlag-order,
            .packageDetail-routeAnchor-order,
            .packageDetail-routeShip-order {
              display: inline-block;
              width: 22px;
              font-size: 12px;
              color: #4a90e2;
              letter-spacing: 0;
            }
            .packageDetail-routePlane-order {
              width: 40px;
            }
            .packageDetail-routePlane-date,
            .packageDetail-routeFlag-date,
            .packageDetail-routeAnchor-date,
            .packageDetail-routeShip-date {
              display: inline-block;
              width: 44px;
              
              font-size: 12px;
              color: #4a90e2;
              letter-spacing: 0;
            }
            .packageDetail-routePlane-icon,
            .packageDetail-routeFlag-icon,
            .packageDetail-routeAnchor-icon,
            .packageDetail-routeShip-icon {
              display: inline-block;
              width: 18px;
              text-align: center;
              height: 18px;
              background-color: #febc10;
              border-radius: 50%;
              -webkit-border-radius: 50%;
              margin-left: 20px;
              vertical-align: middle;
              margin-right: 10px;
            }
            .packageDetail-routeShip-icon {
              background: #4a90e2;
            }
            .packageDetail-routeShip-icon2 {
              background: #2f6aae;
            }
            .packageDetail-routePlane-txt,
            .packageDetail-routeFlag-txt,
            .packageDetail-routeAnchor-txt,
            .packageDetail-routeShip-txt {
              font-size: 14px;
              color: #333333;
              letter-spacing: 1px;
              vertical-align: middle;
              // margin-left: -4px;
            }
            .packageDetail-routePlane-icon img,
            .packageDetail-routeFlag-icon img,
            .packageDetail-routeAnchor-icon img,
            .packageDetail-routeShip-icon img {
              width: 12px;
              position: relative;
              top: -2px;
            }
            .packageDetail-routeItem-stay {
              font-size: 12px;
              color: #999999;
              letter-spacing: 0;
              padding: 4px 0px 4px 20px;
              border-left: 1px dotted #ccc;
              margin-left: 112px;
            }
          }
          .packageDetail-routePlace-tip {
            padding-top: 11px;
            padding-bottom: 5px;
            font-size: 11px;
            line-height: 15px;
            color: #999;
          }
        }
      }
      .packageDetail-routeDetail {
        margin: 15px 0;
        text-align: center;
        span {
          display: inline-block;
          width: 126px;
          text-align: center;
          height: 24px;
          line-height: 24px;
          border: 1px solid #4a90e2;
          border-radius: 25px;
          border-radius: 25px;
          color: #4a90e2;
          font-size: 14px;
        }
      }
    }

    .package-orderNotes {
      margin-top: 10px;
      .package-orderNotesCon {
        padding-bottom: 13px;
        .package-orderNotes-top {
          padding: 16.5px 20px 0 20px;
          background-color: #fff;
          .package-orderNotes-title {
            img {
              width: 18px;
              font-size: 0;
              vertical-align: middle;
            }
            span {
              display: inline-block;
              vertical-align: middle;
              margin-left: 2px;
              
              font-size: 15px;
              color: #333333;
              letter-spacing: 0;
              font-weight: bold;
            }
          }
        }

        .orderNotesCon {
          .package-orderNotes-category {
            margin-bottom: 10px;
            padding: 10px 20px;
            background-color: #fff;
            .package-orderNotes-headline {
              overflow: hidden;
              .package-orderNotes-headline-l {
                height: 14px;
                line-height: 14px;
                float: left;
                display: inline-block;
                
                font-size: 14px;
                color: #4a90e2;
                letter-spacing: 1px;
                padding-left: 8px;
                border-left: 3px solid #4a90e2;
                position: relative;
                top: 6px;
              }
              .package-orderNotes-headline-r {
                float: right;
                margin-right: 4px;
                img {
                  width: 8px;
                }
              }
            }
          }
        }
      }
    }
  }

  .searchPackage-priceIcon {
    position: fixed;
    bottom: 150px;
    right: 4px;
    width: 32px;
    height: 32px;
    padding-top: 4px;
    opacity: 0.8;
    background: #4a90e2;
    z-index: 10;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    font-size: 10px;
    color: #fff;
    line-height: 12px;
    text-align: center;
    &.js-ticketTips {
      bottom: 190px;
      background: #febc10;
    }
  }
}

// 特别礼遇
.specialBookingText {
  font-size: 11px;
  padding-left: 28px;
  padding-top: 10px;
}

.specialBookingText img {
  width: 18px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
}

.specialBookingText .specialBookingName {
  color: #BA9153;
}

.specialBookingText .rightArrows {
  width: 6px;
  height: 10px;
  padding-left: 3px;
  img{
    width: 6px;
    height: 10px;
  }
}

.specialBookingMobileBanner {
  margin-bottom: -5px;
}

.specialBookingMobileBanner img {
  width: 100%;
}

.package-travel {
  .package-travelTitle {
    padding: 10px 20px;
    > img {
      width: 20px;
      height: 16px;
      font-size: 0;
      vertical-align: middle;
    }
    > span {
      
      font-size: 15px;
      color: #333333;
      letter-spacing: 0;
      margin-left: 6px;
      vertical-align: middle;
    }
  }
}

.searchPackage-scrollTop {
  position: fixed;
  bottom: 110px;
  right: 4px;
  width: 32px;
  text-align: center;
  height: 32px;
  opacity: 0.8;
  background: #4a90e2;
  z-index: 10;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  display: none;
  img {
    width: 13px;
    margin-top: 8px;
  }
}

.room-tags {
  position: absolute;
  top: -1px;
  left: -1px;
  border-radius: 10px 0 10px 0;
  height: 0.6rem;
  & > img {
    display: block;
    height: 100%;
  }
}

.room-type-switch {
  position: absolute;
  top: 2px;
  right: 2px;
  border-radius: 0.35rem;
  height: 0.35rem;
  width: 0.35rem;
  background-color: #ff0000;
}
.viewVrMiniSite{
  position: absolute;
  top: 20px;
  right: 0;
  width: 80px;
  height: 30px;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  overflow: hidden;
  background-color: rgba(254, 200, 65, 0.69);
  & a{
    width: 100%;
    height: 100%;
    font-size: 10px;
    font-weight: bold;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    & img{
      width: 22px;
      height: 15px;
    }
  }
}
.outOfStock-con{
  border-top: 1px solid #E6E6E6;
  margin: -5px 0 0;
  padding: 12px 0;
  max-height: 85vh;
  overflow-y: auto;
  width: 100vw;
  .outOfStock-title{
    font-size: 14px;
    color: #232323;
    line-height: 20px;
    position:relative;
    padding-left: 12px;
    font-weight: bold;
    margin: 0 20px;
  }
  .outOfStock-title:after{
    content: '';
    display: inline-block;
    width: 3px;
    height: 14px;
    background: #FCC300;
    position: absolute;
    left: 0;
    top: 3px;
  }
  .recommendedRoute-list{
    width: 100%;
    height: 300px;
    margin: 10px 0;
    padding-left: 8px;
  }
  .outOfStock-roomName{
    font-weight: 400;
    font-size: 14px;
    color: #0E0E0E;
    line-height: 20px;
    margin: 10px 0 10px 20px;
    padding-left: 12px;
    display: flex;
    align-items: center;
    .roomName{
      position: relative;
      padding: 0 5px;
    }
    .roomName:after{
      content:'';
      width: 100%;
      height: 8px;
      background-color: #FCC300;
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: -1;
    }
  }
  .selectRoom-main{
    padding: 0 20px 0 32px;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 20px;
    .selectRoom-item{
      width: 50%;
      height: 28px;
      text-align: center;
      font-size: 14px;
      line-height: 28px;
      background: #F6F6F6;
      border-radius: 3px;
      color: #666666;
    }
    .active{
      background-color: #FCC300;
      color: #FFFFFF;
    }
  }
  .confirmBtn{
    height:  40px;
    line-height: 40px;
    background: linear-gradient( 225deg, #00AEEA 0%, #006AB6 100%);
    border-radius: 4px;
    font-weight: 600;
    font-size: 14px;
    text-align: center;
    color: #FFFFFF;
    margin: 23px 20px 4px;
  }
  .haveRegistered{
    height:  40px;
    line-height: 40px;
    background: #E9E9E9;
    border-radius: 4px;
    font-weight: 600;
    font-size: 14px;
    text-align: center;
    color: #A7A7A7;
    margin: 23px 20px 4px;
  }
  .outOfStock-tips{
    font-weight: 400;
    font-size: 12px;
    color: #666666;
    text-align: center;
  }
}
.tips-text{
  position: absolute;
  bottom: 175px;
  left: 50%;
  transform: translate(-50%,-50%);
  text-align: center;
  font-size: 14px;
  color: #fff;
  width: 238px;
  height: 46px;
  border-radius: 5px;
  line-height: 46px;
  background: rgba(0,0,0,0.6);
}
.c_doubleroom{

}
.optOfSellOut{
  font-size: 10px;
}
.countdown-main{
  width: 100%;
  background: linear-gradient( 94deg, #FA531F 0%, #FE7E4C 100%);
  margin: 8px 0;
  padding: 10px;
  box-sizing: border-box;
  color: #fff;
  & .countdown-con{
    font-weight: 500;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-top: 5px;
  }
}
.countdown-title{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1px;
  & .title-con{
    display: flex;
    align-items: center;
    gap: 5px;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 22px;
    width: calc(100% - 170px);
    & div{
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 16px;
    }
  }
  & img{
    width: 16px;
    height: 16px;
    display: block;
  }
  & .title-time {
    font-size: 12px;
    display: flex;
    gap: 3px;
    & .title-time-con{
      font-weight: 500;
      font-size: 10px;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      gap: 3px;
      & span{
        font-weight: 500;
        font-size: 12px;
        color: #DB0100;
        height: 15px;
        line-height: 15px;
        background: #FFFFFF;
        border-radius: 2px;
        text-align: center;
        min-width: 21px;
      }
    }
  }
}

.folded-box{
  background-color: #f9c500;
  width: 100%;
  height: 31px;
  margin-bottom: 20px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 10px;
  border-radius: 5px;
  font-size: 12px;
}
.folded-box-text{
  margin-right: 8px;
}
.folded-box img{
  width: 10px;
  height: 6px;
}
.folded-box-text-img{
  transform: rotate(180deg);
}

/* 选房助手 按钮 start */
.helper{
  position: absolute;
  width: 82px;
  height: 28px;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
  border-radius: 14px 0 0 14px;
  background: linear-gradient(136deg, rgba(2, 229, 241, 1), rgba(2, 229, 241, 1), rgba(187, 192, 253, 1));
  right: -10px;
  
}

.helper .inner{
  width: 80.5px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #fff;
  border-radius: 12.5px 0 0 12.5px;
  background: linear-gradient(90deg, #0271BC 0%, #03A8E3 100%);
}

.helper .helper-icon{
  width: 15px;
  height: 14px;
  margin-right: 3px;
}

/* 选房助手 按钮 end */

.salesCountdownBox {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0 3px;
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 2;
  padding: 0 4px;
  height: 20px;
  border-radius: 2px;
  background-color: #FA531F;
  .barDesc {
    font-size: 11px;
    height: 13px;
    line-height: 13px;
    color: #fff;
  }
}
</style>
